import React, { CSSProperties } from "react";
// HIS new architecture
import Landing from "react-lib/apps/HISV3/common/Landing";
import MeHealthLanding from "react-lib/apps/HISV3/common/MeHealthLanding";
import MeHeyLanding from "react-lib/apps/HISV3/common/MeHeyLanding";
import LoadingScreen from "react-lib/apps/HISV3/common/LoadingScreen";
import Debug from "react-lib/apps/HISV3/common/Debug";
import setUpController from "./setUpController";
import TopBar from "./TopBar";
import * as ViewAppointment from "./ViewAppointment";
import * as ViewRegistration from "./ViewRegistration";
import * as ViewEncounter from "./ViewEncounter";

import * as MainVideoCall from "./MainVideoCall";
import * as MemberHealthKit from "./MemberHealthKit";

// IsHealth
import DoctorSchedule from "./IsHealth/DoctorSchedule";
import CardDoctorSchedule from "react-lib/apps/HISV3/APP/CardDoctorSchedule";
import CardDoctorFeeReportOld from "react-lib/apps/HISV3/APP/CardDoctorFeeReport";
import CardTelemedRecord from "react-lib/apps/IsHealth/Dashboard/CardTelemedRecord";
import Studio from "./IsHealth/Studio";
import CreateOA from "./IsHealth/CreateOA";
import SettingOAAccount from "Main/SettingOAAccount";
import VaccineUpload from "./VaccineUpload/VaccineUpload";
import ErrorBoundary from "react-lib/apps/common/ErrorBoundary";
import StaffChat from "react-lib/apps/MSG/StaffChat";
import CardSettingTRTOptions from "react-lib/apps/HISV3/DEN/CardSettingTRTOptions";
import CardSettingMediaDocument from "react-lib/apps/HISV3/DEN/CardSettingMediaDocument";

// MEH
import CardPhysiotherapistSignUpRequest from "react-lib/apps/MEH/CardPhysiotherapistSignUpRequest";
import CardPhysiotherapistList from "react-lib/apps/MEH/CardPhysiotherapistList";
import CardOAMemberList from "react-lib/apps/MEH/CardOAMemberList";
import CardPaymentSlip from "react-lib/apps/MEH/CardPaymentSlip";
import CardSellerSettingPackage from "react-lib/apps/MEH/CardSellerSettingPackage";
import CardHolidaySetting from "react-lib/apps/MEH/CardHolidaySetting";
import CardAffiliateCommission from "react-lib/apps/MEH/CardAffiliateCommission";
import CardAppointmentListMEH from "react-lib/apps/MEH/CardAppointmentListMEH";
import CardScheduleSetting from "react-lib/apps/MEH/CardScheduleSetting";
import ClinicCMS from "react-lib/apps/CMS/ClinicCMS";
import CardMeCastBroadcastApproval from "react-lib/apps/MeForm/CardMeCastBroadcastApproval";
import CardDialogChatList from "react-lib/apps/MSG/CardDialogChatList";
import CardMeBillingMain from "react-lib/apps/MEH/CardMeBillingMain";
import CardSettingService from "react-lib/apps/MEH/CardSettingService";
import CardGenQRCode from "react-lib/apps/MEH/CardGenQRCode";
import CardMePOSCRM from "react-lib/apps/MEH/CardMePOSCRM";

import LocalizationWrapper from "react-lib/localization/LocalizationWrapper";

// CSS
import "semantic-ui-offline/semantic.min.css";
import "react-table-6/react-table.css";
import "react-table-hoc-fixed-columns/lib/styles.css";
import "react-toastify/dist/ReactToastify.css";

import "react-lib/apps/QUE/Time.css";

import "react-lib/css/ReactTable.css";
import "react-lib/css/ReactTableFixedColumns.css";

import "react-lib/css/CardLayout.css";
import "react-lib/css/ANCRecordTable.css";
import "assets/fonts.css";

// From CUDENT2
import CardDentistSchedule from "react-lib/apps/Scheduling/CardDentistSchedule";
import CardDivisionSchedule from "react-lib/apps/Scheduling/CardDivisionSchedule";
import CardHoliday from "react-lib/apps/Scheduling/CardHoliday";
import CardChair from "react-lib/apps/Scheduling/CardChair";
import CardStatistics from "react-lib/apps/Scheduling/CardStatistics";

// ANS
import CardSetupAnesthesiaTemplate from "react-lib/apps/HISV3/ANE/CardSetupAnesthesiaTemplate";
// ORM
import CardManageOperatingRoom from "react-lib/apps/HISV3/ORM/CardManageOperatingRoom";

// Port bplus 55888
import QAChatTable from "react-lib/apps/IsHealth/Platform/QAChatTable";
import ModSelectAppointment from "react-lib/apps/IsHealth/Common/ModSelectAppointment";
// Port bplus 55887
import Dashboard from "react-lib/apps/IsHealth/Dashboard/Dashboard";
import CardQueueForPatient from "react-lib/apps/IsHealth/Dashboard/CardQueueForPatient";
import ShowRequestOA from "react-lib/apps/IsHealth/Platform/ShowRequestOA";
import EmailCallback from "react-lib/apps/IsHealth/Common/EmailLogin/EmailCallback";
import LineCallBack from "react-lib/apps/IsHealth/Common/Line/LineCallBack";
import UserProfile from "react-lib/apps/IsHealth/REG/UserProfile";

// CLM
import CardCreateInvoiceGroup from "react-lib/apps/HISV3/CLM/CardCreateInvoiceGroup";
import CardExportEClaimFile from "react-lib/apps/HISV3/CLM/CardExportEClaimFile";
import CardOPDDownloadSentClaimFile from "react-lib/apps/HISV3/CLM/CardOPDDownloadSentClaimFile";
import CardUploadPatientCoverage from "react-lib/apps/HISV3/CLM/CardUploadPatientCoverage";
import CardImportLabValuesCalcDoctorFee from "react-lib/apps/HISV3/CLM/CardImportLabValuesCalcDoctorFee";
import CardDoctorFeeSummary from "react-lib/apps/HISV3/CLM/CardDoctorFeeSummary";
import CardDoctorFeeReport from "react-lib/apps/HISV3/CLM/CardDoctorFeeReport";
import CardClaimTaxDocument from "react-lib/apps/HISV3/CLM/CardClaimTaxDocument";
import CardAIPNSendClaim from "react-lib/apps/HISV3/CLM/CardAIPNSendClaim";
import CardSendClaimResponseFile from "react-lib/apps/HISV3/CLM/CardSendClaimResponseFile";
import CardCostCenterReceipt from "react-lib/apps/HISV3/CLM/CardCostCenterReceipt";
import CardSapAccountingReport from "react-lib/apps/HISV3/CLM/CardSapAccountingReport";
import CardBillingPYInterface from "react-lib/apps/HISV3/CLM/CardBillingPYInterface";
import CardTriggerDischargeInterface from "react-lib/apps/HISV3/CLM/CardTriggerDischargeInterface";
import CardDrugTransferInterface from "react-lib/apps/HISV3/CLM/CardDrugTransferInterface";
import CardDrugDispensingInterface from "react-lib/apps/HISV3/CLM/CardDrugDispensingInterface";
import CardTriggerInvoiceitem from "react-lib/apps/HISV3/CLM/CardTriggerInvoiceitem";
import CardOperatingOrderInterface from "react-lib/apps/HISV3/CLM/CardOperatingOrderInterface";
import CardDoctorFeeOrderInterface from "react-lib/apps/HISV3/CLM/CardDoctorFeeOrderInterface";
import CardLabOrderInterface from "react-lib/apps/HISV3/CLM/CardLabOrderInterface";
import CardPatientRecordInterface from "react-lib/apps/HISV3/CLM/CardPatientRecordInterface";
import CardImagingOrderInterface from "react-lib/apps/HISV3/CLM/CardImagingOrderInterface";
import CardTreatmentOrderInterface from "react-lib/apps/HISV3/CLM/CardTreatmentOrderInterface";
import CardDFInterface from "react-lib/apps/HISV3/CLM/CardDFInterface";
import CardEditDivisionSupplyOrder from "react-lib/apps/HISV3/CLM/CardEditDivisionSupplyOrder";
import CardBillingBLInterface from "react-lib/apps/HISV3/CLM/CardBillingBLInterface";
import CardPdfMakeHeaderPreview from "react-lib/apps/HISV3/CLM/CardPdfMakeHeaderPreview";
import CardGenerateOutboundFreezeTime from "react-lib/apps/HISV3/CLM/CardGenerateOutboundFreezeTime";
import CardGenerateContinueByDate from "react-lib/apps/HISV3/CLM/CardGenerateContinueByDate";
import CardGenerateContinueByPlan from "react-lib/apps/HISV3/CLM/CardGenerateContinueByPlan";
import CardAddNedDrugOrderItem from "react-lib/apps/HISV3/CLM/CardAddNedDrugOrderItem";
import CardPayroll from "react-lib/apps/HISV3/HRM/CardPayroll";

// PHR
import CardUnderlyingDisease from "react-lib/apps/HISV3/PHR/CardUnderlyingDisease";
import CardDrugDiseaseInteraction from "react-lib/apps/HISV3/PHR/CardDrugDiseaseInteraction";
import CardHealthMember from "react-lib/apps/HISV3/PHR/CardHealthMember";

// TPD
import CardNotiMessage from "react-lib/apps/HISV3/TPD/CardNotiMessage";
import CardBillLockNotiMessage from "react-lib/apps/HISV3/BIL/CardBillLockNotiMessage";

// HCU
import CardSettingPackage from "react-lib/apps/HISV3/HCU/CardSettingPackage";
import CardSettingQueue from "react-lib/apps/HISV3/HCU/CardSettingQueue";
import CardSettingAppointmentReminder from "react-lib/apps/HISV3/HCU/CardSettingAppointmentReminder";
import CardStaffSetting from "react-lib/apps/USER/CardStaffSetting";
import CardUploadTemplateExcel from "react-lib/apps/USER/CardUploadTemplateExcel";
import CardPrinterList from "react-lib/apps/USER/CardPrinterList";
import CardOrderSetTemplate from "react-lib/apps/HISV3/common/CardOrderSetTemplate";
import CardAccountInformation from "react-lib/apps/USER/CardAccountInformation";

// BIL
import CardFinancialReport from "react-lib/apps/HISV3/BIL/CardFinancialReport";
import CardClinicAnnualReport from "react-lib/apps/HISV3/BIL/CardClinicAnnualReport";
import CardReceiptAr from "react-lib/apps/HISV3/BIL/CardReceiptAr";
import CardWithDrawalRules from "react-lib/apps/HISV3/BIL/CardWithDrawalRules";

// MSD
import CardSupplyServiceChecking from "react-lib/apps/HISV3/MSD/dispensing/CardSupplyServiceChecking";

// HRM
import CardWorkSchedule from "react-lib/apps/HISV3/HRM/CardWorkSchedule";
import CardEmployeeInfoManagement from "react-lib/apps/HISV3/HRM/CardEmployeeInfoManagement";
import CardTrainingManagement from "react-lib/apps/HISV3/HRM/CardTrainingManagement";
import CardLeavePolicy from "react-lib/apps/HISV3/HRM/CardLeavePolicy";
import CardSelfServiceSchedule from "react-lib/apps/HISV3/HRM/CardSelfServiceSchedule";
import CardTrainingInfoManagement from "react-lib/apps/HISV3/HRM/CardTrainingInfoManagement";
import CardEmployeeProfile, { TabsNameType } from "react-lib/apps/HISV3/HRM/CardEmployeeProfile";

// WKP
import CardWorkPlan from "react-lib/apps/HISV3/WKP/CardWorkPlan";

// SegmentTarget
import CardSegmentTargetManage from "react-lib/apps/segment/CardSegmentTargetManage";

// MeForm
import CardMeFormMain from "react-lib/apps/MeForm/CardMeFormMain";
import CardMeCastMain from "react-lib/apps/MeForm/CardMeCastMain";

// MeGen
import CardMeGenMain from "react-lib/apps/MeGen/CardMeGenMain";
import CardMeGenCostMain from "react-lib/apps/MeGen/CardMeGenCostMain";
import { createPurReceiptRuntimeAccess } from "react-lib/apis/PUR/purReceiptCreate";
import CardMeERP from "./MeERP/CardMeERP";
import CardMeScriptMain from "react-lib/apps/MEH/CardMeScriptMain";

// From cnmicro
import { DOCTOR_ORDER_ACRONYM, DOCTOR_ORDER_BG_COLOR } from "../_qmljs/Common/Util";
import * as CONSTANT from "react-lib/utils/constant";
import ControllerAdapter from "./ControllerAdapter";
import CardOPDClaimResolve from "react-lib/apps/ARM/CardOPDClaimResolve";
import CardCreateARTransactionContainer from "react-lib/apps/ARM/CardCreateARTransactionContainer";
import CardUploadSentClaimResponseFile from "react-lib/apps/ARM/CardUploadSentClaimResponseFileContainer";
import CardCreateARTransaction from "react-lib/apps/ARM/CardCreateARTransaction";
import CardSentClaimInformation from "react-lib/apps/ARM/CardSentClaimInformation";
import CardUploadSentClaimResult from "react-lib/apps/ARM/CardUploadSentClaimResult";

import CardSegment from "react-lib/apps/segment/CardSegment";

// import ARReview from "./AR/ARReview";
// import DataScience from "./AR/DataScience";
import { vcMessenger, WSMessenger } from "react-lib/compat/vc-websocket";

// Misc
import { toast } from "react-toastify";
import { formatDropdown } from "react-lib/utils";
import { deliveryStatusOptions } from "react-lib/apps/HISV3/TPD/telepharOptions";
import MainHISController from "./MainHISController";
import * as MainHISI from "./MainHISInterface";
import { SetPropSeparate } from "react-lib/frameworks/SetProp";
import Cookies from "js-cookie";
import { injectIntl, WrappedComponentProps } from "react-intl";

import ChatSupport from "react-lib/apps/IsHealth/Common/ChatSupport";
import SnackMessage from "react-lib/apps/common/SnackMessage";
import CardLabCost from "react-lib/apps/lab_cost/CardLabCost";

import TabPenta from "react-lib/frameworks/TabPenta";
import PasswordLoginManager from "react-lib/apps/IsHealth/Common/PasswordLogin/PasswordLoginManager";
import {
  ADMIN_ICON_LIST,
  ADMIN_LABEL_LIST,
  ADMIN_NAME_LIST,
} from "react-lib/apps/USER/CardSettingDivision";
import { canAccessAdminMenu, canAccessMeGenCost } from "react-lib/apps/MeGen/common/megenPermissions";
import CardPermissionManagement from "react-lib/apps/USER/CardPermissionManagement";

import CardRehabDevice from "react-lib/apps/HISV3/RHB/CardRehabDevice";

import { CRMBackoffice } from "crm-backoffice/integration";
import { makeHostCrmApi } from "./crm/hostCrmApi";

import CONFIG from "config/config";
import { ISCHART_INFORMATICS_GS, ISCHART_STUDIO_GS } from "informatics/config";
import {
  Icon,
  Image,
  Label,
  Popup,
  Header,
  Progress,
  Grid,
  DropdownProps,
  Dimmer,
  Loader,
} from "semantic-ui-react";
import { handleSetupMessageHtml } from "react-lib/apps/IsHealth/Chat/MessageContentHTML";
import ButtonPayment from "react-lib/apps/IsHealth/Common/ButtonPayment";
import { getDeviceIdAndUserSubScription } from "react-lib/apps/HISV3/common/sequence/GetUserSubScription";
import CardAppointmentSummary from "react-lib/apps/Scheduling/CardAppointmentSummary";
import { setUserId } from "firebase/analytics";
import Me from "ischart-deploy/components/Me";
import CardBuyBillingPackage from "react-lib/apps/MEH/CardBuyBillingPackage";
import CardMakeAppointmentMeHey from "react-lib/apps/MEH/appointments/CardMakeAppointmentMeHey";
import { AppointmentMeHey } from "react-lib/apps/MEH/appointments/AppointmentMeHeyUtils";
import CardIsChartWrapper from "react-lib/apps/MeForm/CardIsChartWrapper";
import CardMeChart from "react-lib/apps/MeChart/CardMeChart";
import CardMeSettingPackage from "react-lib/apps/MEH/CardMeSettingPackage";
import { FormattedMessage } from "react-intl";

const WS_HOST = `${CONFIG.WS_HOST}`;

const IMAGES = {
  IHlogo: "images/IHlogo.png",
  logo: "images/IHimage.png",
  appointment: "/static/images/menus/appointment.png",
  queue: "/static/images/menus/queue.png",
  search: "/static/images/menus/search.png",
  telemed: "/static/images/menus/telemed.png",
  report: "/static/images/menus/report.png",
  chatSupport: "/static/images/menus/chat-support.png",
  staffChat: "/static/images/menus/staff-chat.png",
  memberHealthKit: "/static/images/menus/ep_monitor.png",
};

const styles = {
  tab_icon: {
    padding: "0.5rem",
    height: "65px",
    display: "grid",
    placeContent: "center",
    width: "54px",
  } as CSSProperties,
};

const languageOptions = [
  { key: "th", value: "th", text: "TH", flag: "th" },
  { key: "en", value: "en", text: "EN", flag: "us" },
];

const EMPLOYEE_SELF_PROFILE_HIDDEN_TABS: TabsNameType[] = [
  "Division/Special permission",
  "Employee Document",
  "Employee payment detail",
  "Employee info history",
];

export class MainHIS extends React.Component<
  MainHISI.Props & WrappedComponentProps,
  MainHISI.State
> {
  controller: MainHISController;

  // Handle legacy controller
  proxyController: any;
  crdFormViewerController: any;
  nurseNoteController: any;
  subICD10DetailController: any;
  crdAppointmentRequestNewController: any;
  modSearchDoctorNoteController: any;
  subDoctorScheduleController: any;
  consultController: any;
  crdAdmitOrderController: any;
  crdAdmissionFormController: any;
  cardDischargeController: any;
  cardImageGalleryController: any;
  cardMedCertController: any;
  crdMultiDisciplinaryController: any;
  modOrderDetailController: any;
  scannedDocumentController: any;
  printListController: any;
  queueController: any;
  dashboardController: any;
  ruleListController: any;
  chatController: any;
  diagFormController: any;
  patientPanelController: any;
  progressNoteController: any;
  classifyController: any;
  crdVitalSignController: any;
  diagComposerController: any;
  drugOrderHistoryController: any;
  drugOrderQueueController: any;
  appointmentDashboardController: any;
  cardANSBillController: any;
  cardSentClaimInformationController: any;
  hasProgressionCycle: any;

  chatBoxRef: any;
  staffChatRef: any;
  chatSupportRef: any;
  chatListRef: any;
  // qaChatTable: any;
  qaChatTableRef: any;
  dashboardRef: any;
  tabPatientRef: any;
  tabAdminRef: any;
  tabUserRef: any;
  tabSellerRef: any;
  tabSubAppointmentRef?: any;
  lastReadMessage: any;
  openVideoCallModal: boolean;
  closeOverriding: boolean;
  videoCallRoom: string;
  currChatChannelId: string;
  currPatientId: string;
  vcMessengerQueue: any;
  vcMessengerMSG: any;
  vcMessengerBil: any;
  vcMessengerShp: any;
  serviceQueueRef: any;
  transferOrderCount: number;

  constructor(props: MainHISI.Props) {
    super(props);
    console.log(" ");
    this.state = { ...MainHISI.StateInitial };
    this.controller = new MainHISController(
      () => {
        return this.state;
      },
      (state, callback) => {
        this.setState(state, callback);
      },
      window,
    );
    this.setState = this.setState.bind(this);
    this.controller.setProp = SetPropSeparate(this, "");
    this.controller.cookies = Cookies;

    this.controller.apiToken = Cookies.get("apiToken") || "";
    this.controller.data.user = parseInt(Cookies.get("user_id") || "0");
    this.controller.data.division = parseInt(Cookies.get("division_id") || "0");
    this.controller.data.device = parseInt(Cookies.get("device_id") || "0");

    if (CONFIG.USE_THEME) {
      document.documentElement.setAttribute("data-theme", CONFIG.USE_THEME);
    } else if (CONFIG.COMPANY === "MEHEALTH") {
      document.documentElement.setAttribute("data-theme", "mehealth");
    } else {
      document.documentElement.setAttribute("data-theme", "penta");
    }
    // To convert legacy controller to handleEvent call
    this.proxyController = Object.fromEntries(
      ControllerAdapter.map((item: readonly [string, readonly string[]]) => [
        item[0],
        (...args: any) =>
          this.controller.handleEvent({
            message: item[0] as MainHISI.Event["message"],
            params:
              item[1].length === 0
                ? args.length === 0
                  ? {}
                  : args[0]
                : item[1].reduce((obj: object, paramName: string, index: number) => {
                    return {
                      ...obj,
                      [paramName]: index < args.length ? args[index] : null,
                    };
                  }, {}),
          } as MainHISI.Event),
      ]),
    );

    setUpController(this);

    this.chatBoxRef = React.createRef();
    this.staffChatRef = React.createRef();
    // this.qaChatTable = React.createRef();
    this.qaChatTableRef = React.createRef();
    this.dashboardRef = React.createRef();
    this.tabPatientRef = React.createRef();
    this.tabAdminRef = React.createRef();
    this.tabUserRef = React.createRef();
    this.tabSellerRef = React.createRef();
    this.tabSubAppointmentRef = React.createRef();
    this.serviceQueueRef = React.createRef();

    this.lastReadMessage = null;
    this.openVideoCallModal = false;
    this.closeOverriding = false;
    this.videoCallRoom = "";
    this.currChatChannelId = "";
    this.currPatientId = "";
    this.vcMessengerQueue = new WSMessenger();
    this.vcMessengerMSG = new WSMessenger();
    this.vcMessengerBil = new WSMessenger();
    this.vcMessengerShp = new WSMessenger();
    this.transferOrderCount = 0;

    this.vcMessengerMSG.onMessage((message: any) => {
      console.log("debug ~ message vcMessenger:", message);
      this.handleOnMessageMSG(message);
    });

    this.vcMessengerQueue.onMessage((message: any) => {
      console.log("debug ~ message vcMessengerQueue:", message);
      this.handleOnMessageQueue(message);
    });

    this.vcMessengerBil.onMessage((message: any) => {
      this.handleOnMessageBil(message);
    });

    this.vcMessengerShp.onMessage((message: any) => {
      this.handleOnMessageShp(message);
    });

    // Initial DuckDB If config
    this.controller.handleEvent({
      message: "DidMount",
      params: {},
    });
  }

  componentDidMount = async () => {
    // window.addEventListener("message", this.handlePaymentPostMessages);

    // Intercept Issue 63382 login by cert
    const params = new URLSearchParams(window.location.search);

    const auth_ver: any = params.get("auth_ver") || "1";
    const app = CONFIG.APP_NAME; // "isHealth"
    const email = params.get("email") || "";
    const firstName = params.get("first_name") || "";
    const lastName = params.get("last_name") || "";
    const time = params.get("time") || "";
    const sign = params.get("sign") || "";
    const role = params.get("role") || "";
    const division = params.get("division") || "";
    const title = params.get("title") || "";
    const security_group = params.get("security_group") || "";
    const care_provider_code = params.get("care_provider_code") || "";

    if (sign && role && care_provider_code) {
      // Login by cert
      const plm = new PasswordLoginManager();
      let data = null;
      try {
        data = await plm.requestTokenByCertLogin({
          app,
          auth_ver,
          care_provider_code,
          division,
          email,
          firstName,
          lastName,
          role,
          security_group,
          sign,
          time,
          title,
        });

        console.log("requestTokenByCertLogin data:", data);
      } catch (error) {
        // ไปหน้า login
        console.error("error: ", error);
        const url = new URL(window.location.origin);
        url.searchParams.set("app", "HIS");
        window.history.replaceState({}, "", url);
        return this.controller.handleEvent({
          message: "Logout",
          params: {},
        });
      }

      if (data?.token && data?.profile?.userId) {
        Cookies.set("apiToken", data?.token, { path: "/" });
        Cookies.set("user_id", data?.profile?.userId, { path: "/" });
        this.controller.apiToken = data?.token;
        const url = new URL(window.location.origin);
        url.searchParams.set("app", "HIS");
        window.history.replaceState({}, "", url);
      }
    }

    const pathname = globalThis.location.pathname;
    const isEmailCallback = pathname === "/email-callback/";
    const isLineCallback = pathname === "/callback";

    let isLineSignIn = false;

    try {
      isLineSignIn = !!globalThis.opener?.onLineSignInSuccess;
    } catch {
      isLineSignIn = false;
    }

    if (isEmailCallback && !this.controller.apiToken) {
      this.setState({ showEmailCallback: true });
      return;
    }

    if (isLineCallback && (!this.controller.apiToken || isLineSignIn)) {
      this.setState({ showLineCallback: true });

      return;
    }

    const drug_id = params.get("drug_id");
    const encounter_id = params.get("encounter_id");
    const division_id = params.get("division_id");
    const staff_chat = params.get("staff_chat");
    const admin_chat = params.get("admin_chat");
    const patientId = params.get("patient_id");
    const channel_id = params.get("channel_id");
    const hn = params.get("hn");
    const open = params.get("open") as "Scheduling" | "SearchPatient" | "ServiceQueue" | null;
    const tab = params.get("tab");
    const menu = params.get("menu");
    const receiptId = params.get("receipt_id");


    // console.log("componentDidMount drug_id: ", drug_id);
    // console.log("componentDidMount encounter_id: ", encounter_id);
    // console.log("componentDidMount division_id: ", division_id);
    // console.log("componentDidMount staff_chat: ", staff_chat);
    // console.log("componentDidMount patientId: ", patientId);
    // console.log("componentDidMount hn: ", hn);
    // console.log("componentDidMount open: ", open);
    // console.log("componentDidMount tab: ", tab);

    let defaultSideMenu = "";

    // console.log("continue SetState apiToken:  ", Cookies.get("apiToken"));
    // console.log("continue SetState user_id", Cookies.get("user_id"));
    // console.log("continue SetState user_lang", Cookies.get("user_lang"));

    console.log("open:", open);

    if (open === "Scheduling") {
      defaultSideMenu = "Appointment";

      if (patientId && hn) {
        this.setState({
          goToCreateAppointment: {
            selectedPatient: { id: Number(patientId), hn },
          },
        });
      }

      const url = new URL(window.location.href);

      url.searchParams.delete("patient_id");
      url.searchParams.delete("hn");
      url.searchParams.delete("open");
      window.history.replaceState({}, "", url.toString());
    } else if (open === "SearchPatient") {
      defaultSideMenu = "Registration";

      if (patientId) {
        this.setState({ initialLayout: 1 });

        this.runSequence({
          sequence: "SetPatient",
          action: "select",
          patient: { id: Number(patientId) },
          restart: true,
        });
      }
    } else if (open === "ServiceQueue") {
      defaultSideMenu = "Encounter";

      if (division_id && tab) {
        this.controller.handleEvent({
          message: "ChangeDivision",
          params: {
            divisionId: division_id,
            isRefresh: true,
            noDefaultTabIndex: true,
            tabPatientList: tab,
          },
        });
      }
    } else if (encounter_id && drug_id) {
      this.setState({ initialLayout: 1 });
      // ดูก่อน ว่ามี SelectedDrugOrderWorking Component
      this.controller.handleEvent({
        message: "SelectDrugOrderWorking",
        params: {
          drugOrder: { id: drug_id, encounter: encounter_id },
          initial: true,
        },
      });
    } else if (encounter_id && division_id) {
      if (this.controller.apiToken) {
        this.handleGetEncounter();
      }
    } else if (staff_chat && !CONFIG.DISABLED_USER_MODE) {
      this.setState({ goToStaffChat: true, mode: "user" });
    } else if (admin_chat && division_id && channel_id) {
      this.setState({ goToAdminMenu: "แชท" });

      this.controller.handleEvent({
        message: "ChangeDivision",
        params: { divisionId: division_id, isRefresh: true },
      });
    } else if (menu === "MePOS" && patientId) {
      if (division_id) {
        await this.controller.handleEvent({
          message: "ChangeDivision",
          params: {
            divisionId: division_id,
            isRefresh: true,
          },
        });
      }

      this.setState({
        mode: "admin",
        goToAdminMenu: "MePOS",
      });

      await this.controller.handleEvent({
        message: "RunSequence",
        params: {
          sequence: "MeBilling",
          action: "SELECTED_INITIAL_MENU",
          data: {
            patient: patientId,
            receipt: receiptId,
          },
          initialMenu: "ประวัติชำระค่าบริการ",
        },
      });
    }

    this.controller.handleEvent({ message: "HandleOARequestCheck", params: {} });

    await this.controller.handleEvent({
      message: "RunSequence",
      params: { sequence: "AppInitialize", defaultSideMenu },
    });

    const hideStaffChat = CONFIG.V3_HIDDEN_TAB_LIST.includes("Staff Chat");
    // const hideAdminChat = CONFIG.V3_HIDDEN_TAB_LIST.includes("แชท");

    if (!hideStaffChat) {
      this.controller.handleEvent({
        message: "GetUnreadMessageCountStaff",
        params: { all: true },
      });
    }

    // if (!hideAdminChat) {
    //   this.controller.handleEvent({
    //     message: "GetUnreadMessageCountStaff",
    //     params: { all: true, isChatPatientOnly: true },
    //   });
    // }

    this.controller.handleEvent({ message: "GetBillingLockNotifications", params: {} });
  };

  componentDidUpdate = (prevProps: any, prevState: any) => {
    // window.removeEventListener("message", this.handlePaymentPostMessages);

    if (
      this.state.selectedDivision?.id !== prevState.selectedDivision?.id &&
      this.state.selectedDivision?.id
    ) {
      // console.log('vc- componentDidUpdate prevState.selectDivision?.id: ', prevState.selectDivision?.id);
      // console.log('vc- componentDidUpdate this.state.selectedDivision?.id: ', this.state.selectedDivision?.id);
      this.connectWebSocket(this.state.selectedDivision);

      const hideAdminChat = CONFIG.V3_HIDDEN_TAB_LIST.includes("แชท");

      if (!hideAdminChat) {
        this.controller.handleEvent({
          message: "GetUnreadMessageCountStaff",
          params: { all: true, isChatPatientOnly: true },
        });
      }
    } else {
      // console.log('vc- componentDidUpdate not called ',this.state.selectedDivision?.id);
    }

    if (this.state.userId && this.state.userId !== prevState.userId) {
      CONFIG.updateConfig();
      CONFIG.updateVersion();
      if (this.controller.analytics) {
        setUserId(this.controller.analytics, String(this.state.userId));
      }
    }

    if (this.state.django?.user?.id && this.state.django?.user?.id !== prevState.django?.user?.id) {
      this.controller.handleEvent({ message: "GetRejectOrderNotifications", params: {} });
    }

    if (
      this.state.goToMenu &&
      (this.state.selectedEncounter || this.state.SetPatientSequence?.patient?.id)
    ) {
      const tabs = Array.from(document.querySelectorAll(".tab-menu.--framework > [id*=tab-]"));
      console.log("MainHIS tabs: ", tabs);

      const index = tabs.findIndex((elm) => elm.textContent?.trim()?.includes(this.state.goToMenu));

      // console.log("MainHIS Change selectedRecordViewIndex: ", index);
      // console.log("MainHIS Change this.state.goToMenu: ", this.state.goToMenu);
      // console.log("MainHIS Change this.state.SetPatientSequence?.patient?.id: ", this.state.SetPatientSequence?.patient?.id);

      if (index === -1) {
        this.setState({
          selectedRecordViewIndex: 0,
          goToMenu: "",
        });
      } else if (tabs.length) {
        this.setState({
          selectedRecordViewIndex: index,
          goToMenu: "",
        });
      }
    }

    if (
      this.state.goToAdminMenu &&
      this.state.mode === "admin" &&
      this.state.loggedin &&
      this.tabAdminRef
    ) {
      const menu = this.state.goToAdminMenu;

      setTimeout(() => {
        this.tabAdminRef?.changeTabKey?.(menu);
      }, 300);

      this.setState({ goToAdminMenu: "" });
    }

    if (this.state.errorMessage !== null && !this.controller.apiToken) {
      const message = this.state.errorMessage;
      console.log("message", this.state.errorMessage, message);
      if (message?.password && message?.username) {
        toast.error("username และ password ไม่ถูกต้อง");
      } else {
        if (message?.password) {
          toast.error("password ไม่ถูกต้อง");
        } else if (message?.username) {
          toast.error("username ไม่ถูกต้อง");
        } else if (message?.non_field_errors) {
          toast.error("ไม่สามารถเข้าใช้งานด้วยใบรับรองนี้");
        } else if (message?.request_token_errors) {
          toast.error("กรุณาล็อคอินใหม่อีกครั้ง");
        } else if (message?.server) {
          toast.error(message.server);
        }
      }
      this.controller.setProp("errorMessage", null);
    }
  };

  connectWebSocket = (target_division: any) => {
    console.log("vc-websocket connectWebSocket: target_division ", target_division);
    // Need to send DJANGO via REST instead of template rendering
    if ((this.vcMessengerMSG as any).isSupported) {
      // Connect to websocket
      if (!this.vcMessengerMSG.isConnecting()) {
        if (!this.vcMessengerMSG.isConnected()) {
          // Prevent duplicate connection
          console.log("vc-websocket connectWebSocket... ", this.state.selectedDivision);
          this.vcMessengerMSG.connect(
            "MSG",
            {
              screens: target_division?.id ? target_division.id : "",
              token: this.controller.apiToken,
            },
            WS_HOST,
          );
        }
      }

      this.handleConnectVCMessenger(this.vcMessengerQueue, "ServiceQueue");

      this.handleConnectVCMessenger(this.vcMessengerBil, "MainBIL");

      if (
        this.state.divisionOptions?.some((item) => item.value === 6788 || item.text === "Telephar")
      ) {
        this.handleConnectVCMessenger(this.vcMessengerShp, "SHP");
      }
    } else {
      // Websocket not supported
      console.error("Websocket not supported");
    }
  };

  handleConnectVCMessenger = (vcMessenger: any, screens: any) => {
    if (!vcMessenger.isConnecting()) {
      if (!vcMessenger.isConnected()) {
        // Prevent duplicate connection
        console.log("vc-websocket connectWebSocket... ", this.state.selectedDivision);
        vcMessenger.connect(
          screens === "SHP" ? screens : this.state.selectedDivision?.id,
          {
            screens: screens,
            token: this.controller.apiToken,
          },
          WS_HOST,
        );
      }
    }
  };

  handleOnMessageMSG = (message: any) => {
    console.log(" vcMessenger.onMessage", { message });
    if (this.chatListRef?.getChatList) {
      this.chatListRef?.getChatList();
    }

    if (message["data_message_type"] === "MESSAGE") {
      const isChatBoxRef = !("current" in (this.chatBoxRef || {})) && this.chatBoxRef;

      if (!isChatBoxRef && this.state.chatDetail?.chat_channel) {
        this.updateUnreadMessageCount("detail", message);
      }

      if (!isChatBoxRef && !!this.state.encounterList?.length) {
        this.updateUnreadMessageCount("encounter", message);
      }

      if (this.state.allChatRoomList?.length) {
        this.updateUnreadMessageCount("staff", message);
      }

      if (Array.isArray(this.state.allAdminChatRoomIds)) {
        this.updateUnreadMessageCount("admin", message);
      }

      if (this.chatBoxRef?.receivedMessage) {
        this.chatBoxRef.receivedMessage({
          chatChannelId: parseInt(message["channel_id"]),
        });
      }

      const isQaChatTableRef = !("current" in (this.qaChatTableRef || {})) && this.qaChatTableRef;

      if (isQaChatTableRef && this.qaChatTableRef) {
        if (this.qaChatTableRef.chatBoxRef) {
          this.qaChatTableRef.chatBoxRef.receivedMessage({
            chatChannelId: parseInt(message["channel_id"]),
          });
        }
        this.qaChatTableRef.receivedMessage?.({
          chatChannelId: parseInt(message["channel_id"]),
        });
      }

      // #if (config.CLASSIFY_CHAT || config.AIRFLOW_CHAT) {
      //   if (qaChatTable) {
      //     if (qaChatTable.chatBoxRef) {
      //       qaChatTable.chatBoxRef.getLastMessage({
      //         chatChannelId: parseInt(message["channel_id"]),
      //       });
      //     }
      //     if (qaChatTable.chatBoxRef) {
      //       qaChatTable.chatBoxRef.receivedMessage({
      //         chatChannelId: parseInt(message["channel_id"]),
      //       });
      //     }
      //     qaChatTable.receivedMessage({
      //       chatChannelId: parseInt(message["channel_id"]),
      //     });
      //   }
      // }

      if (message["content_type"] === "activity") {
        if (
          message.user_name !== this.controller.data?.userProfile?.username &&
          message.channel_id !== this.chatBoxRef?.chatChannelId
        ) {
          this.setState({ showIconNoti: true });
        }
        //
        console.log(" need refresh chat !! this.chatBoxRef: ", this.chatBoxRef);
        console.log(" need refresh chat !! this.chatBoxRef?.current: ", this.chatBoxRef?.current);
        console.log(" need refresh chat !! this.staffChatRef: ", this.staffChatRef);
        console.log(
          " need refresh chat !! this.staffChatRef?.current: ",
          this.staffChatRef?.current,
        );
        this.staffChatRef?.getChatChannelList?.({
          channelId: message.channel_id,
        });
      }
    } else if (message["data_message_type"] === "MESSAGE_READ") {
      if (this.lastReadMessage === message.message_id) {
        return;
      }

      this.lastReadMessage = message.message_id;

      if (this.chatBoxRef?.receivedMessageRead) {
        this.chatBoxRef.receivedMessageRead({
          chatChannelId: parseInt(message["channel_id"]),
          messageId: parseInt(message["message_id"]),
        });
      }

      if (this.chatBoxRef?.receivedMessage) {
        this.chatBoxRef.receivedMessage({
          chatChannelId: parseInt(message["channel_id"]),
        });
      }

      const isQaChatTableRef = !("current" in (this.qaChatTableRef || {})) && this.qaChatTableRef;

      if (isQaChatTableRef && this.qaChatTableRef) {
        this.qaChatTableRef.receivedMessage?.({
          chatChannelId: parseInt(message["channel_id"]),
        });
      }
    } else if (message["event"] === "RECLASSIFY") {
      if (this.chatBoxRef?.loadPatientEncounter) {
        this.chatBoxRef.loadPatientEncounter();
      }

      const isQaChatTableRef = !("current" in (this.qaChatTableRef || {})) && this.qaChatTableRef;

      if (isQaChatTableRef && this.qaChatTableRef) {
        this.qaChatTableRef?.getListTriageLevel?.();
      }
    } else if (message["event"] === "DIAG_FORM_UPDATED") {
      const isQaChatTableRef = !("current" in (this.qaChatTableRef || {})) && this.qaChatTableRef;

      if (isQaChatTableRef && this.qaChatTableRef) {
        this.qaChatTableRef?.updateDiagForm?.({
          patientId: parseInt(message["patient_id"]),
        });
      }
    } else if (message["event"] === "PATIENT_APPOINTMENT_UPDATE" && message["status"] === 3) {
      this.serviceQueueRef?.refreshTelapharQueueRef?.();
      this.controller.handleEvent({
        message: "HandleUpdateNotiMessage",
        params: {
          data: {
            id: `PATIENT_APPOINTMENT_UPDATE-${message.patient_appointment_id}`,
            title: `นัดหมายของ HN : ${message.hn}`,
            description: "ถูกเลื่อนเวลานัดหมาย",
            type: "APPOINTMENT",
          },
          update: true,
        },
      });
    } else if (message["event"] === "Locker.ACTION.UNLOCK_REQUEST") {
      this.controller.handleEvent({
        message: "HandleUpdateBillLockNotiMessage",
        params: {
          data: {
            id: message.encounter_id,
            locker_lock_level: message.locker_lock_level,
            locker_lock_type: message.locker_lock_type,
          },
        },
      });

      this.controller.handleEvent({ message: "GetBillingLockNotifications", params: {} });
    }
  };

  handleOnMessageQueue = (message: any) => {
    console.log(" vcMessengerQueue.onMessage", { message });

    if (message["event"] === "NEW_LAB_ORDER") {
      this.serviceQueueRef?.refreshLabOrderQueue?.();
    } else if (message["event"] === "REJECTED_SPECIMEN") {
      this.serviceQueueRef?.refreshLabOrderQueue?.();
    } else if (message["event"] === "update_drug_transfer_request") {
      this.setState({ transferOrderCount: this.transferOrderCount + 1 });
    } else if (message["event"] === "update_supply_transfer_request") {
      this.setState({ transferOrderCount: this.transferOrderCount + 1 });
    } else if (message["event"] === "update_imaging_queue") {
      setTimeout(() => {
        this.serviceQueueRef?.refreshImagingWorkList?.();
      }, 1250);
    } else if (message["event"] === "update_rejected_order") {
      this.controller.handleEvent({ message: "GetRejectOrderNotifications", params: {} });
    }
  };

  handleOnMessageBil = (message: any) => {
    console.log(" vcMessengerBil.onMessage", { message });

    if (
      message["source"] === "BIL" &&
      ["BIL_RECALCULATE", "BIL_RECALCULATE_ENCOUNTER"].includes(message["event"])
    ) {
      // investigate only current on screen patient
      if (message.patient === this.state.selectedEncounter?.patient_id) {
        if (message.status === "IN_PROGRESS" || message.status === "WAITING") {
          this.controller.handleEvent({
            message: "HandleRefreshTaskTracking",
            params: {},
          });
        } else if (message.status === "COMPLETED" || message.status === "FAILED") {
          this.setState({ taskTrackingList: [] });
          this.controller.handleEvent({
            message: "HandleRefreshEncounter" as any,
            params: {},
          });
          this.controller.handleEvent({
            message: "HandleGetEncounterSuspension" as any,
            params: {},
          });
        }
      }
    } else if (
      message["source"] === "BIL" &&
      message["event"] === "BIL_UPDATE_RECEIPT" &&
      message["status"] === "COMPLETED"
    ) {
      this.controller.handleEvent({
        message: "GetCreditNoteItem" as any,
        params: {
          action: "printReceipt",
          data: message,
        },
      });
    } else if (message["event"] === "BIL_REPORT_PRINT") {
      if (message.task_id === this.state.billReportPrint?.task_id) {
        this.setState({
          billReportPrint: {
            ...this.state.billReportPrint,
            status: message.status,
            progress: message.progress,
          },
        });

        if (message.status === "COMPLETED") {
          this.controller.handleEvent({
            message: "HandleReportPrintTrackingResult",
            params: { taskId: message.task_id },
          });
        } else if (message.status === "FAILED") {
          this.setState({
            billReportPrint: { error: "ผิดพลาด" },
          });
        }
      }
    } else if (message["event"] === "drug_order_payment_status_updated") {
      const drugOrder = this.state.selectedDrugOrderWorking || {};

      if (drugOrder.pk === message.order_id) {
        this.controller.handleEvent({
          message: "SelectDrugOrderWorking",
          params: {
            drugOrder: { ...drugOrder, id: drugOrder.pk },
            isNotGetEncounter: true,
          },
        });
      }
    }
  };

  handleOnMessageShp = (message: any) => {
    console.log(" vcMessengerShp.onMessage", { message });

    if (message["source"] === "SHP" && message["event"] === "SHIPPING_UPDATE") {
      const status = deliveryStatusOptions.find(
        (option) => option.value === message.delivery_status,
      );
      // เหตุผลที่เรียกรถ Lalamove ไม่สำเร็จ (delivery_status = ERROR)
      const description =
        message.delivery_status === "ERROR" && message.delivery_error
          ? `${status?.text || ""}: ${message.delivery_error}`
          : status?.text;

      this.controller.handleEvent({
        message: "HandleUpdateNotiMessage",
        params: {
          data: {
            id: `SHIPPING_UPDATE-${message.shipping_order_id}`,
            description,
            image: status?.img,
            divisionId: message.division_id,
            organizationId: message.organization_id,
            type: "SHP",
          },
        },
      });
    }
  };

  handleLoginSuccess = () => {
    this.handleGetEncounter();
  };

  handleGetEncounter = () => {
    const params = new URLSearchParams(window.location.search);
    const encounter_id = params.get("encounter_id");
    const division_id = params.get("division_id");
    const menu = params.get("menu");

    if (!(encounter_id && division_id)) {
      return;
    }

    this.setState({ initialLayout: 1 });

    this.controller.handleEvent({
      message: "GetEncounterInfo",
      params: { encounterId: encounter_id, goToMenu: menu },
    });
    this.controller.handleEvent({
      message: "ChangeDivision",
      params: { divisionId: division_id, isRefresh: true },
    });
  };

  handleEpisodeSelected = async (episode: any) => {
    this.setState({ eocIsLoading: true });
    const [data, error] = await this.proxyController.changeENToEpisode({
      encounterId: this.state.selectedEncounter.id,
      episodeId: episode.id,
    });
    if (error) {
      if (error.message) {
        toast.error(error.message);
      } else {
        toast.error(JSON.stringify(error));
      }
      this.setState({ eocIsLoading: false });
      return;
    }
    const enEpData = await this.getEncounterOfEpisode(episode.id);
    this.setState({ eocIsLoading: false });
    this.setState({
      eocEncounterList: enEpData?.enList || [],
      episodeInfo: episode,
      eocEpisodeSelected: { id: episode.id, date_time: episode.created_at },
      eocEnEpData: enEpData,
    });

    if (episode.episode_type === "ANC") {
      setTimeout(() => {
        // waiting for state value
        this.openANCRecord();
      }, 0);
    }
  };

  openANCRecord = () => {
    this.setState({ openNote: CONSTANT.LOADING_ANIMATION.OPENING }, () => {
      setTimeout(() => {
        this.setState({ openNote: CONSTANT.LOADING_ANIMATION.OPENED });
        // if (this.state.openConsult) {
        //   this.CardAppointmentRequestConsult.refresh();
        // }
      }, 0);
    });
  };

  getEncounterOfEpisode = async (episodeID: number) => {
    const [enListData, enError] = await this.proxyController.getENListFromEpisode(episodeID);
    if (enError) {
      console.log("Error: Get encounter of episode!, ", enError);
      return null;
    }
    // Prepare data
    var enList = [];
    var epType = "";
    var epName = "";
    for (var item of enListData.items) {
      var diagnosis = "";
      for (var d of item.diagnoses) {
        if (d.type_name === "PRIMARY") {
          diagnosis += diagnosis === "" ? d.icd_term : ", " + d.icd_term;
        }
      }
      var orderList = [];
      for (var o of item.doctor_orders) {
        var a: any = {
          id: o.id,
          text: (DOCTOR_ORDER_ACRONYM as { [key: string]: any })[o.specific_type],
          color: (DOCTOR_ORDER_BG_COLOR as { [key: string]: any })[o.order_status],
        };
        orderList.push(a);
      }
      // Data
      var en = {
        id: item.id,
        date_time: item.created,
        encounter: item.number,
        doctor: item.doctor_name,
        diagnosis: diagnosis,
        order: orderList,
      };
      enList.push(en);
      epType = item.episode_type_label;
      epName = item.episode_name;
    }

    const enEpData = { enList: enList, epType: epType, epName: epName };
    return enEpData;
  };

  updateUnreadMessageCount = async (type: string, message: any) => {
    if (type === "detail") {
      this.controller.setProp(
        "chatDetail.unread_message_count",
        (this.state.chatDetail.unread_message_count || 0) + 1,
      );
    } else if (type === "encounter") {
      const update = (this.state.encounterList || []).map((item: any) => ({
        ...item,
        unread_message_count:
          item.division === message.division_id && item.chat_channel === message.channel_id
            ? message.user_name === this.controller.data?.userProfile?.username
              ? 0
              : (item.unread_message_count || 0) + 1
            : item.unread_message_count,
      }));

      this.setState({ encounterList: [...update] });
    } else if (["staff", "admin"].includes(type)) {
      if (this.chatBoxRef) {
        if (
          this.chatBoxRef?.chatChannelId &&
          this.chatBoxRef?.chatChannelId === message.channel_id
        ) {
          this.staffChatRef?.getChatChannelList?.({
            channelId: message.channel_id,
          });

          return;
        }
      }

      if (message.user_name !== this.controller.data?.userProfile?.username) {
        const list = type === "staff" ? this.state.allChatRoomList : this.state.allAdminChatRoomIds;
        const foundChat = list?.find((id: number) => id === message.channel_id);

        if (foundChat) {
          this.setState({ showIconNoti: true });

          this.staffChatRef?.getChatChannelList?.({
            channelId: message.channel_id,
          });

          const isStaffChatRef = !("current" in (this.staffChatRef || {})) && this.staffChatRef;

          if (type === "admin" && !isStaffChatRef) {
            this.controller.handleEvent({
              message: "GetUnreadMessageCountStaff",
              params: { all: true, isChatPatientOnly: true },
            });
          }
        } else if (type === "admin") {
          this.controller.handleEvent({
            message: "GetUnreadMessageCountStaff",
            params: { all: true, isChatPatientOnly: true },
          });
        }
      }
    }
  };

  handleCancelENFromEpisode = async (row: any) => {
    // Change episode
    this.setState({
      eocIsLoading: true,
      episodeInfo: {},
      openNote: CONSTANT.LOADING_ANIMATION.CLOSED,
    });
    const [data, error] = await this.proxyController.cancelENFromEpisode(
      this.state.selectedEncounter.id,
    );
    if (error) {
      toast.error(error);
      this.setState({ eocIsLoading: false });
      return;
    }
    this.setState({
      eocEncounterList: [],
      episodeInfo: {},
      eocEpisodeSelected: { id: -1, date_time: "" },
      eocIsLoading: false,
    });
  };

  handleGetDoctorSpecialty = async () => {
    const [data, error] = await this.proxyController.getSpeciality();
    if (error) {
      toast.error(error);
    }
    let specialtiesList = formatDropdown(data, "name", "id");
    let list = specialtiesList.map((item: any) => {
      delete item.is_active;
      delete item.display_seq;
      return item;
    });
    this.setState({ searchDoctorSpecialties: list });
  };

  handleSearchDoctor = async (name: any, div: any, doctorCurrentPage: any) => {
    if (!doctorCurrentPage) {
      doctorCurrentPage = this.state.searchDoctorCurrentPage;
    }
    let limit = 40;
    let params = {
      nameCode: name,
      specialty: div,
      offset: (doctorCurrentPage - 1) * limit,
      limit: limit,
    };
    const [doctorListData, doctorListError, numberOfPage] =
      await this.proxyController.getDoctorList(params);
    if (doctorListError) {
      toast.error(doctorListError);
    }
    if (numberOfPage) {
      this.setState({ searchDoctorNumberOfPage: numberOfPage });
    }
    // TODO: handle error doctorListError
    this.setState({ searchDoctorList: doctorListData });
  };

  removeCardScannedDocument = () => {
    const items = [...(this.state.items || [])];
    if (items.length > 0) {
      var pos = 0;
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (item.key === "Common/CardScannedDocument") {
          pos = i;
          break;
        }
      }
      items.splice(pos, 1);
      this.setState({
        items: items,
        openCardScannedDocument: CONSTANT.LOADING_ANIMATION.CLOSED,
      });
    }
  };

  togglePrintList = () => {
    if (this.state.openPrintList === CONSTANT.LOADING_ANIMATION.OPENED) {
      this.closeModalPrintList();
    } else {
      this.openModalPrintList();
    }
  };

  checkOATabMenu = (name: any) => {
    if (this.state.loginWithSocial) {
      const data = this.state.userProfile ?? {};
      const isInfoComplete = MainHISI.checkInComplete(data);
      const tabs: string[] = [ADMIN_NAME_LIST["ข้อมูลส่วนตัว"]];

      if (isInfoComplete) {
        tabs.push(ADMIN_NAME_LIST["สร้าง Official Account"]);
      }

      return tabs.includes(name);
    }

    return false;
  };

  openModalPrintList = () => {
    this.setState({ openPrintList: CONSTANT.LOADING_ANIMATION.OPENED }, () => {
      this.morePopupClose();
    });
  };

  morePopupClose = () => this.setState({ openMorePopup: false });

  closeModalPrintList = () => {
    this.setState({ openPrintList: CONSTANT.LOADING_ANIMATION.CLOSED });
  };

  handleClickBell = () => {
    const hideStaffChat = CONFIG.V3_HIDDEN_TAB_LIST.includes("Staff Chat");
    const hideAdminChat = CONFIG.V3_HIDDEN_TAB_LIST.includes("แชท");

    if (this.state.showIconNoti && !hideStaffChat) {
      this.setState({ mode: "user", goToStaffChat: true });
    } else if (this.state.showIconNoti && !hideAdminChat) {
      this.setState({ mode: "admin" });

      setTimeout(() => {
        this.tabAdminRef?.changeTabKey?.("แชท");
      }, 300);
    }
  };

  handleReadAllMessages = () => {
    if (this.state.showIconNoti && !CONFIG.DISABLED_USER_MODE) {
      this.setState({ showIconNoti: false });
    }

    if (this.state.adminChatUnreadCount?.length) {
      this.setState({ adminChatUnreadCount: "" });
    }
  };

  runSequence = (params: any) =>
    this.controller.handleEvent({ message: "RunSequence", params: params });

  /**
   * ตัวเชื่อม API ของเมนู MeCRM — สร้างครั้งเดียวต่อ (token, division)
   *
   * ⚠️ ห้ามเรียก makeHostCrmApi() ตรง ๆ ใน render
   *    มันคืน object ใหม่ทุกครั้ง ทำให้ useEffect ในโมดูลที่ผูกกับ prop `api`
   *    ยิงซ้ำไม่รู้จบจนหน้าค้าง
   */
  crmApiCache: { key: string; api: ReturnType<typeof makeHostCrmApi> } | null = null;

  getCrmApi = () => {
    const apiToken = this.controller.apiToken || "";
    const divisionId = this.state.selectedDivision?.id || 0;
    const key = `${apiToken}|${divisionId}`;

    if (this.crmApiCache?.key !== key) {
      this.crmApiCache = { key, api: makeHostCrmApi({ apiToken, divisionId }) };
    }

    return this.crmApiCache.api;
  };

  // Port bplus 55888
  handleCreateAppointment = ({ contentPayload, appointmentId }: any = {}) => {
    let id = contentPayload ? contentPayload.patient_appointment : appointmentId;

    this.setState({ patientAppointmentId: id, openModChooseAppointment: true });
    // setPatientAppointmentId(id);
    // setOpenModChooseAppointment(true);
  };

  handleNavigationMessage = ({ content = "", contentPayload = null } = {}) => {
    if (content.includes("{ตารางออกตรวจผู้ให้คำปรึกษา}")) {
      let contentArr = content.split("{ตารางออกตรวจผู้ให้คำปรึกษา}");
      return (
        <div>
          {contentArr.map((item, index) => {
            if (index !== contentArr.length - 1) {
              return (
                <>
                  {item}
                  <span
                    className="textButton"
                    onClick={() => this.handleCreateAppointment({ contentPayload })}
                  >
                    ตารางออกตรวจผู้ให้คำปรึกษา
                  </span>
                </>
              );
            }
            return <></>;
          })}
        </div>
      );
    } else if (
      content.includes("{กดเพื่อยืนยันการจัดส่งยา}") ||
      contentPayload.target === "drug_address"
    ) {
      return (
        <>
          {handleSetupMessageHtml(content.replace(/{กดเพื่อยืนยันการจัดส่งยา}/g, ""), undefined)}
          <ButtonPayment
            title={this.props.intl.formatMessage({ id: "bplusClinicKey1352" })}
            // callback
          />
        </>
      );
    } else {
      return handleSetupMessageHtml(content, null);
    }
  };

  handleStaffChatDidMount = () => {
    this.setState({ goToStaffChat: false });
  };

  handleSocialLoginSuccess = (params: any) => {
    const response = params.pentaToken || params;

    if (!response) {
      return;
    }

    this.controller.handleEvent({
      message: "HandleLoginSuccess",
      params: {
        login: response,
        verify: params.verify,
        onSuccess: () => {
          this.setState({ showEmailCallback: false });
          this.setState({ showLineCallback: false });

          globalThis.history.pushState(null, "", "/?app=HIS");
        },
      },
    });
  };

  handleSocialLoginFailed = () => {
    this.setState({ showEmailCallback: false });
    this.setState({ showLineCallback: false });

    toast.error("เข้าสู่ระบบไม่สำเร็จ");

    globalThis.history.pushState(null, "", "/?app=HIS");
  };

  handleRefreshUserInfo = (response: Record<string, any>) => {
    const data = {
      last_name: response.last_name,
      last_name_en: response.last_name_en,
      first_name: response.first_name,
      first_name_en: response.first_name_en,
      full_name: response.fullname,
      birth_date: response.dob,
      email: response.email,
      phone_no: response.phone_no,
    };

    const profile = {
      ...this.state.userProfile,
      ...data,
    };

    this.controller.data.userProfile = profile;

    this.controller.setState({
      userProfile: profile,
      django: {
        ...this.state.django,
        user: { ...this.state.django.user, full_name: data.full_name },
      },
      ...(this.state.showRequestOA?.isPending && {
        showRequestOA: { open: true, isPending: false },
      }),
    });
  };

  // Call to wrapper
  // handleChangeLanguage = (e: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
  //   this.setState({ userSelectedLanguage : data?.value as "en" | "th"})
  //   Cookies.set("user_lang", data?.value as string)
  // }

  render() {
    const label = this.props.intl.formatMessage({ id: "เปิด" });
    //  console.log('MainHIS label: ', label);

    const extraString =
      this.state.divisionHasUserItems?.find(
        (di: any) => di.division.id === this.state.django?.division,
      )?.extra || "{}";

    const extra = JSON.parse(extraString);
    const isAccessPatient = typeof extra.isAccessPatient === "undefined" || extra.isAccessPatient;
    const adminMenuAccessContext = {
      adminMenuDivisions: this.state.adminMenuDivisions,
      selectedDivisionId: this.state.selectedDivision?.id,
      loginWithSocial: this.state.loginWithSocial,
      isSuperUser: this.controller.data.userProfile?.is_superuser,
      divisionType: this.state.divisionType,
    };
    const canViewMeGenCost = canAccessMeGenCost(adminMenuAccessContext);
    // console.log("this.state", this.state);
    // console.log(" this.state.selectedDivision?.code" , this.state.selectedDivision?.code)
    // console.log("!!! CONFIG.SCREEN_ITEM !!! ", CONFIG.SCREEN_ITEM);

    return (
      <div style={{ overflowY: "hidden", height: "100%" }} className="main-nurse">
        {/* <button onClick={()=> { this.methodDoesNotExist.sds()}}>Test Sentry</button> */}

        {this.state.showLineCallback ? (
          <LineCallBack
            hostname={CONFIG.API_HOST}
            onLoginSuccess={this.handleSocialLoginSuccess}
            onLoginFailed={this.handleSocialLoginFailed}
          />
        ) : this.controller.apiToken === "" ? (
          <>
            {this.state.showEmailCallback ? (
              <>
                <EmailCallback
                  onLoginSuccess={this.handleSocialLoginSuccess}
                  onLoginFailed={this.handleSocialLoginFailed}
                />
                <LoadingScreen />
              </>
            ) : (
              <>
                {CONFIG.COMPANY === "MEHEALTH" ? (
                  // <MeHealthLanding
                  //   setProp={this.controller.setProp}
                  //   controller={this.proxyController}
                  //   AppInitializeSequence={this.state.AppInitializeSequence}
                  //   loadingLogin={this.state.loadingLogin}
                  //   onLoginSuccess={this.handleSocialLoginSuccess}
                  //   onLoginSubmit={() =>
                  //     this.runSequence({
                  //       sequence: "AppInitialize",
                  //       action: "LoginSubmit",
                  //       onSuccess: this.handleLoginSuccess,
                  //       type: "email",
                  //     })
                  //   }
                  // />
                  <MeHeyLanding
                    setProp={this.controller.setProp}
                    controller={this.proxyController}
                    AppInitializeSequence={this.state.AppInitializeSequence}
                    loadingLogin={this.state.loadingLogin}
                    onLoginSuccess={this.handleSocialLoginSuccess}
                    onLoginSubmit={() =>
                      this.runSequence({
                        sequence: "AppInitialize",
                        action: "LoginSubmit",
                        onSuccess: this.handleLoginSuccess,
                        type: "email",
                      })
                    }
                    selectedLanguage={this.props.userSelectedLanguage?.includes("th") ? "th" : "en"}
                    onChangeSelectedLanguage={this.props.onChangeLanguage}
                    languageUX={this.props.userSelectedLanguage}
                  />
                ) : (
                  <div style={{ height: "100%", background: "#1ABDD4" }}>
                    <Landing
                      setProp={this.controller.setProp}
                      AppInitializeSequence={this.state.AppInitializeSequence}
                      loadingLogin={this.state.loadingLogin}
                      openPassword={this.state.openPassword}
                      languageUX={this.props.userSelectedLanguage}
                      languageOptions={languageOptions}
                      controller={this.proxyController}
                      // callback
                      onChangeLanguage={this.props.onChangeLanguage}
                      onLoginSubmit={() =>
                        this.runSequence({
                          sequence: "AppInitialize",
                          action: "LoginSubmit",
                          onSuccess: this.handleLoginSuccess,
                        })
                      }
                      onLoginFacebookSiteSuccess={() => {}}
                      onLoginSuccess={this.handleSocialLoginSuccess}
                    />
                  </div>
                )}
              </>
            )}
          </>
        ) : !this.state.loggedin ? (
          <LoadingScreen />
        ) : (
          <div className="MainScreen" style={{ height: "100vh" }}>
            <TopBar // 40px
              languageUX={this.props.userSelectedLanguage}
              django={this.state.django}
              onEvent={this.controller.handleEvent}
              onClickBell={this.handleClickBell}
              setProp={this.controller.setProp}
              divisionOptions={this.state.divisionOptions}
              selectedDivision={this.state.selectedDivision}
              deviceOptions={this.state.deviceOptions}
              selectedDevice={this.state.selectedDevice}
              showIconNoti={this.state.showIconNoti}
              billingLockNotificationList={this.state.billingLockNotificationList}
              billLockNotiMessageList={this.state.billLockNotiMessageList}
              rejectOrderNotificationList={this.state.rejectOrderNotificationList}
              tabPatientRef={this.tabPatientRef}
              showTabName={this.state.showTabName || ""}
              mode={this.state.mode}
              isSocialLogin={!!this.state.loginWithSocial}
              languageOptions={languageOptions}
              selectedLanguage={this.props.userSelectedLanguage?.includes("th") ? "th" : "en"}
              onChangeSelectedLanguage={this.props.onChangeLanguage}
              BillingAndPackageSequence={this.state.BillingAndPackageSequence}
              BillingCarts={this.state.BillingCarts}
              BillingCreditWallet={this.state.BillingCreditWallet}
              controller={this.controller}
              runSequence={this.runSequence}
              tabAdminRef={this.tabAdminRef}
              userProfile={this.state.userProfile}
            />
            <div style={{ height: "calc( 100% - 40px)" }}>
              <MainVideoCall.Main
                onEvent={this.controller.handleEvent}
                setProp={this.controller.setProp}
                openVideoCallModal={this.state.openVideoCallModal}
                videoCallRoom={this.state.videoCallRoom}
                closeOverriding={this.state.closeOverriding}
                isPatient={false}
                username={this.state.providerEmployeeInfo?.employee_info?.full_name}
                userProfile={this.controller.data?.userProfile}
                chatController={this.chatController}
                currChatChannelId={this.state.currChatChannelId}
                division_id={
                  this.controller.data.division
                    ? this.controller.data.division
                    : this.state.selectedDivision?.id
                }
                patient_id={
                  this.state.selectedEncounter
                    ? this.state.selectedEncounter?.patient_id
                    : this.state.currPatientId
                }
                encounter_id={this.state.selectedEncounter?.id}
                apiToken={this.controller.apiToken}
                onClose={() => {
                  this.setState({ openVideoCallModal: false });
                }}
                languageUX={this.props.userSelectedLanguage}
              />

              {
                this.state.mode === "admin" ? (
                  <TabPenta
                    ref={(ref: any) => {
                      this.tabAdminRef = ref;
                      // ฝากไว้ให้ sequence สลับแท็บเองได้ ไม่ต้อง drill prop ลงไปทีละชั้น
                      this.controller.data.tabAdminRef = ref;
                    }}
                    selectedTabIndex={0}
                    key={"admin"}
                    tabWidth="150px"
                    collapsible
                    tutorials={this.state.menuHasVideos}
                    renderEmpty={
                      this.state.loginWithSocial &&
                      Object.keys(
                        this.state.adminMenuDivisions?.[this.state.selectedDivision?.id] ?? {},
                      ).length === 0 ? (
                        <div style={{ height: "99%", alignContent: "center", textAlign: "center" }}>
                          <div style={{ margin: "auto", fontSize: "2rem", color: "#b3b3b3" }}>
                            กรุณาตั้งค่าเมนู ‘จัดการสิทธิ์’ เพื่อเปิดใช้งานฟีเจอร์อื่นๆ
                          </div>
                        </div>
                      ) : null
                    }
                    data={[
                      {
                        key: ADMIN_NAME_LIST.ตั้งค่าแพ็กเกจ,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.ตั้งค่าแพ็กเกจ}`,
                        }),
                        // name: ADMIN_NAME_LIST.ตั้งค่าแพ็กเกจ,
                        render: () => (
                          <CardSettingPackage
                            setProp={this.controller.setProp}
                            onEvent={this.controller.handleEvent}
                            // seq
                            runSequence={this.runSequence}
                            SettingPackageSequence={this.state.SettingPackageSequence}
                            // CommonInterface
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            errorMessage={this.state.errorMessage}
                            searchedItemListWithKey={this.state.searchedItemListWithKey}
                            // options
                            masterOptions={this.state.masterOptions}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.ข้อมูลส่วนตัว,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.ข้อมูลส่วนตัว}`,
                        }),
                        icon: ADMIN_ICON_LIST.ข้อมูลส่วนตัว,
                        render: () => (
                          <UserProfile
                            controller={this.proxyController}
                            functionsWithRegion={this.controller.functions}
                            isLineLogin={this.state.loginWithSocial === "line"}
                            isGoogleLogin={this.state.loginWithSocial === "google"}
                            isFacebookLogin={this.state.loginWithSocial === "facebook"}
                            // isEmailLogin={this.state.isEmailLogin}
                            // emailLogin={this.state.emailLogin}
                            layout="detailed"
                            userId={this.controller.data.user}
                            onRefreshUserInfo={this.handleRefreshUserInfo}
                            onCreateOA={() => {
                              this.tabAdminRef.changeTabKey("สร้าง Official Account");
                            }}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["สร้าง Official Account"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["สร้าง Official Account"]}`,
                        }),
                        icon: ADMIN_ICON_LIST["สร้าง Official Account"],
                        render: () => (
                          <CreateOA
                            onEvent={this.controller.handleEvent}
                            controller={this.classifyController}
                            apiToken={this.controller.apiToken}
                            onGetDivision={(divisionId: any) => {}} // Already handled in AppInitialize:GetUserInfo
                            myDivisions={this.state.divisionOptions}
                            layout="detailed"
                            onSetShowMenuNoti={(show: any) => this.setState({ showMenuNoti: show })}
                            userFullName={this.state.providerEmployeeInfo?.employee_info?.full_name}
                            userRoleList={this.state.userRoleList}
                            masterData={this.controller.data.masterData}
                            masterOptions={this.state.masterOptions}
                            onCreated={(divisionId: number) =>
                              this.controller.handleEvent({
                                message: "HandleCreatedOA",
                                params: { divisionId },
                              })
                            }
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.ตั้งค่าเอกสารยินยอม,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.ตั้งค่าเอกสารยินยอม}`,
                        }),
                        render: () => {
                          return (
                            <CardSettingMediaDocument
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // seq
                              runSequence={this.runSequence}
                              SettingMediaDocumentSequence={this.state.SettingMediaDocumentSequence}
                              // CommonInterface
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              // options
                              masterOptions={this.state.masterOptions}
                              languageUX={this.props.userSelectedLanguage}
                            />
                          );
                        },
                      },
                      {
                        key: ADMIN_NAME_LIST.ตั้งค่าชุดทางเลือกการรักษา,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.ตั้งค่าชุดทางเลือกการรักษา}`,
                        }),
                        render: () => {
                          return (
                            <CardSettingTRTOptions
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // seq
                              runSequence={this.runSequence}
                              SettingTRTOptionsSequence={this.state.SettingTRTOptionsSequence}
                              // CommonInterface
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              // options
                              masterOptions={this.state.masterOptions}
                              languageUX={this.props.userSelectedLanguage}
                            />
                          );
                        },
                      },
                      {
                        key: ADMIN_NAME_LIST["ตั้งค่า Official Account"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["ตั้งค่า Official Account"]}`,
                        }),
                        icon: ADMIN_ICON_LIST["ตั้งค่า Official Account"],
                        render: () => {
                          return (
                            <SettingOAAccount
                              onEvent={this.controller.handleEvent}
                              controller={{
                                prxManager: this.proxyController,
                                getHealthFacilityType:
                                  this.classifyController.getHealthFacilityType,
                                ...this.proxyController,
                              }}
                              layout="detailed"
                              apiToken={this.controller.apiToken}
                              division={this.controller.data.division || 0}
                              masterData={this.controller.data.masterData}
                              masterOptions={this.state.masterOptions}
                              languageUX={this.props.userSelectedLanguage}
                            />
                          );
                        },
                      },
                      {
                        key: ADMIN_NAME_LIST.จัดการสิทธิ์,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.จัดการสิทธิ์}`,
                        }),
                        icon: ADMIN_ICON_LIST.จัดการสิทธิ์,
                        render: () => (
                          <CardPermissionManagement
                            setProp={this.controller.setProp}
                            runSequence={this.runSequence}
                            proxyController={this.proxyController}
                            PermissionManagementSequence={this.state.PermissionManagementSequence}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            errorMessage={this.state.errorMessage}
                            selectedDivision={this.state.selectedDivision}
                            masterOptions={this.state.masterOptions}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.แชท,
                        name: (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <label>{`${this.props.intl.formatMessage({ id: "ADMIN_MENU_NAME_Chat" })}${CONFIG.COMPANY === "MEHEALTH" ? ` (${this.props.intl.formatMessage({ id: "ADMIN_MENU_NAME_MeHeyApp" })})` : ""}`}</label>
                            {this.state.adminChatUnreadCount && (
                              <Label
                                data-testid="msg-noti"
                                circular
                                color={"red"}
                                style={{ fontSize: "0.7rem" }}
                              >
                                {this.state.adminChatUnreadCount}
                              </Label>
                            )}
                          </div>
                        ),
                        icon: ADMIN_ICON_LIST.แชท ? (
                          <div
                            style={{
                              display: "flex",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{ width: "20px" }}
                              alt="menu.icon"
                              src={ADMIN_ICON_LIST.แชท}
                            />
                            {this.state.adminChatUnreadCount && (
                              <Label
                                data-testid="msg-noti"
                                circular
                                color={"red"}
                                style={{
                                  fontSize: "0.3rem",
                                  position: "absolute",
                                  top: "-1px",
                                  right: "-1px",
                                }}
                              />
                            )}
                          </div>
                        ) : null,
                        render: () => (
                          <StaffChat
                            className="admin-menu-chat"
                            ref={(ref: any) => {
                              this.staffChatRef = ref;
                              return (this.chatBoxRef = ref?.chatBoxRef || null);
                            }}
                            onEvent={this.controller.handleEvent}
                            chatController={{
                              ...this.chatController,
                            }}
                            diagFormController={this.diagFormController}
                            userId={this.controller.data.user?.toString() || ""}
                            userName={this.state.django?.user?.full_name || ""}
                            userLastName={this.controller.data.userProfile?.last_name || ""}
                            userFirstName={this.controller.data.userProfile?.first_name || ""}
                            isChatPatientOnly
                            apiToken={this.controller.apiToken}
                            divisionId={this.state.selectedDivision?.id}
                            chatRoomList={this.state.chatRoomList}
                            searchUserList={this.state.searchUserList}
                            searchMessageList={this.state.searchMessageList}
                            onReadAllMessages={this.handleReadAllMessages}
                            onOpenVideoCall={(url: string, chat_channel_id: string) =>
                              this.setState({
                                openVideoCallModal: true,
                                videoCallRoom: url,
                                currChatChannelId: chat_channel_id,
                              })
                            }
                            languageUX={this.props.userSelectedLanguage}
                            menuSameLevelTextArea={true}
                            selectedPatientChat={this.state.selectedPatientChat}
                            selectedPatientAppointmentList={
                              this.state.selectedPatientAppointmentList
                            }
                            selectedPatientDiagFormList={this.state.selectedPatientDiagFormList}
                            selectedPatientNoteList={this.state.selectedPatientNoteList}
                            selectedProxyPatient={this.state.selectedProxyPatient}
                            diagFormData={this.state.diagFormData}
                            errorMessage={this.state.errorMessage}
                            setProp={this.controller.setProp}
                            aiBotLists={this.state.aiBotLists}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.ตั้งค่าแจ้งเตือนเรียกคิว,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.ตั้งค่าแจ้งเตือนเรียกคิว}`,
                        }),
                        render: () => (
                          <CardSettingQueue
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            runSequence={this.runSequence}
                            SettingQueueSequence={this.state.SettingQueueSequence}
                            adminMenuDivisions={this.state.adminMenuDivisions}
                            selectedDivision={this.state.selectedDivision}
                            masterOptions={this.state.masterOptions}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.ตั้งค่าแจ้งเตือนนัดหมาย,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.ตั้งค่าแจ้งเตือนนัดหมาย}`,
                        }),
                        icon: ADMIN_ICON_LIST.ตั้งค่าแจ้งเตือนนัดหมาย,
                        render: () => (
                          <CardSettingAppointmentReminder
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            runSequence={this.runSequence}
                            SettingQueueSequence={this.state.SettingQueueSequence}
                            adminMenuDivisions={this.state.adminMenuDivisions}
                            selectedDivision={this.state.selectedDivision}
                            masterOptions={this.state.masterOptions}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.ลงตารางแพทย์,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.ลงตารางแพทย์}`,
                        }),
                        icon: ADMIN_ICON_LIST.ลงตารางแพทย์,
                        render: () => (
                          <CardDentistSchedule
                            key={ADMIN_NAME_LIST.ลงตารางแพทย์}
                            menuName={ADMIN_NAME_LIST.ลงตารางแพทย์}
                            django={this.state.django}
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            runSequence={this.runSequence}
                            chairList={this.state.chairList}
                            chairExistDSBList={this.state.chairExistDSBList}
                            adminMenuDivisions={this.state.adminMenuDivisions}
                            selectedDivision={this.state.selectedDivision}
                            blockList={this.state.blockList}
                            holiday={this.state.holiday}
                            providerBlockList={this.state.providerBlockList}
                            searchedItemList={this.state.searchedItemList}
                            scheduleTemplates={this.state.scheduleTemplates}
                            openModConfirmAddBlock={this.state.openModConfirmAddBlock}
                            masterOptions={this.state.masterOptions}
                            userTokenize={this.state.userTokenize}
                            providerInfo={this.state.providerInfo}
                            allDivisionDict={this.controller.data.allDivisionDict}
                            blockLoadingFilter={this.state.blockLoadingFilter}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },

                      {
                        key: ADMIN_NAME_LIST.บริหารเก้าอี้,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.บริหารเก้าอี้}`,
                        }),
                        render: () => (
                          <CardChair
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            runSequence={this.runSequence}
                            chairList={this.state.chairList}
                            blockList={this.state.blockList}
                            providerBlockList={this.state.providerBlockList}
                            scheduleTemplates={this.state.scheduleTemplates}
                            adminMenuDivisions={this.state.adminMenuDivisions}
                            selectedDivision={this.state.selectedDivision}
                            divisionDict={this.controller.data.divisionDict} // TODO: Check port
                            allDivisionDict={this.controller.data.allDivisionDict}
                            holiday={this.state.holiday}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            blockLoadingFilter={this.state.blockLoadingFilter}
                            languageUX={this.props.userSelectedLanguage}
                            successMessage={this.state.successMessage}
                          />
                        ),
                      },

                      {
                        key: ADMIN_NAME_LIST.ลงตารางเภสัช,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.ลงตารางเภสัช}`,
                        }),
                        render: () => (
                          <CardDentistSchedule
                            key={ADMIN_NAME_LIST.ลงตารางเภสัช}
                            menuName={ADMIN_NAME_LIST.ลงตารางเภสัช}
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            runSequence={this.runSequence}
                            chairList={this.state.chairList}
                            chairExistDSBList={this.state.chairExistDSBList}
                            adminMenuDivisions={this.state.adminMenuDivisions}
                            selectedDivision={this.state.selectedDivision}
                            holiday={this.state.holiday}
                            blockList={this.state.blockList}
                            providerBlockList={this.state.providerBlockList}
                            searchedItemList={this.state.searchedItemList}
                            openModConfirmAddBlock={this.state.openModConfirmAddBlock}
                            scheduleTemplates={this.state.scheduleTemplates}
                            telephar={true}
                            masterOptions={this.state.masterOptions}
                            userTokenize={this.state.userTokenize}
                            allDivisionDict={this.controller.data.allDivisionDict}
                            blockLoadingFilter={this.state.blockLoadingFilter}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.สร้างตารางคลินิก,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.สร้างตารางคลินิก}`,
                        }),
                        icon: ADMIN_ICON_LIST.สร้างตารางคลินิก,
                        render: () => (
                          <CardDivisionSchedule
                            onEvent={this.controller.handleEvent}
                            apiToken={this.controller.apiToken}
                            adminMenuDivisions={this.state.adminMenuDivisions}
                            selectedDivision={this.state.selectedDivision}
                            scheduleTemplates={this.state.scheduleTemplates}
                            loadingStatus={this.state.loadingStatus}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.ตั้งค่าวันหยุด,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.ตั้งค่าวันหยุด}`,
                        }),
                        icon: ADMIN_ICON_LIST.ตั้งค่าวันหยุด,
                        render: () =>
                          CONFIG.COMPANY === "MEHEALTH" ? (
                            <CardHolidaySetting
                              setProp={this.controller.setProp}
                              runSequence={this.runSequence}
                              HolidaySettingSequence={this.state.HolidaySettingSequence}
                              errorMessage={this.state.errorMessage}
                              buttonLoadCheck={this.state.buttonLoadCheck}
                            />
                          ) : (
                            <CardHoliday
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              divisionList={this.state.divisionList}
                              adminMenuDivisions={this.state.adminMenuDivisions}
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              selectedDivision={this.state.selectedDivision}
                              holiday={this.state.holiday}
                              languageUX={this.props.userSelectedLanguage}
                            />
                          ),
                      },
                      {
                        key: ADMIN_NAME_LIST.เวลาเปิดให้บริการ,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.เวลาเปิดให้บริการ}`,
                        }),
                        icon: ADMIN_ICON_LIST.เวลาเปิดให้บริการ,
                        render: () => (
                          <CardScheduleSetting
                            key={ADMIN_NAME_LIST.เวลาเปิดให้บริการ}
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            runSequence={this.runSequence}
                            ScheduleSettingSequence={this.state.ScheduleSettingSequence}
                            HolidaySettingSequence={this.state.HolidaySettingSequence}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            searchedItemListWithKey={this.state.searchedItemListWithKey}
                            selectedDivision={this.state.selectedDivision}
                            errorMessage={this.state.errorMessage}
                            masterOptions={this.state.masterOptions}
                            successMessage={this.state.successMessage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.ตารางผู้ให้บริการ,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.ตารางผู้ให้บริการ}`,
                        }),
                        icon: ADMIN_ICON_LIST.ตารางผู้ให้บริการ,
                        render: () => (
                          <CardScheduleSetting
                            key={ADMIN_NAME_LIST.ตารางผู้ให้บริการ}
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            runSequence={this.runSequence}
                            ScheduleSettingSequence={this.state.ScheduleSettingSequence}
                            HolidaySettingSequence={this.state.HolidaySettingSequence}
                            isProvider
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            errorMessage={this.state.errorMessage}
                            searchedItemListWithKey={this.state.searchedItemListWithKey}
                            selectedDivision={this.state.selectedDivision}
                            masterOptions={this.state.masterOptions}
                            patientHNChatList={this.state.patientHNChatList}
                            successMessage={this.state.successMessage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["เครื่องมือกายภาพบำบัดและ Slot เวลา"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["เครื่องมือกายภาพบำบัดและ Slot เวลา"]}`,
                        }),
                        render: () => (
                          <CardRehabDevice
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            runSequence={this.runSequence}
                            RehabDeviceSequence={this.state.RehabDeviceSequence}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            errorMessage={this.state.errorMessage}
                            languageUX={this.props.userSelectedLanguage}
                            masterOptions={this.state.masterOptions}
                            selectedDivision={this.state.selectedDivision}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.ข้อมูลสถิติ,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.ข้อมูลสถิติ}`,
                        }),
                        render: () => (
                          <CardStatistics
                            controller={this.controller}
                            proxyController={this.proxyController}
                            setProp={this.controller.setProp}
                            onEvent={this.controller.handleEvent}
                            divisionList={this.state.divisionList}
                            adminMenuDivisions={this.state.adminMenuDivisions}
                            selectedDivision={this.state.selectedDivision}
                            searchedItemListWithKey={this.state.searchedItemListWithKey}
                            searchedItemList={this.state.searchedItemList}
                            summaryDoctorList={this.state.summaryDoctorList} // TODO: Check
                            summaryStatisticsList={this.state.summaryStatisticsList} // TODO: Check
                            summaryWaitingQueueList={this.state.summaryWaitingQueueList} // TODO: Check
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["คำขอเป็นสมาชิกนักกายภาพ MeHealth"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["คำขอเป็นสมาชิกนักกายภาพ MeHealth"]}`,
                        }),
                        icon: ADMIN_ICON_LIST["คำขอเป็นสมาชิกนักกายภาพ MeHealth"],
                        render: () => {
                          return (
                            <CardPhysiotherapistSignUpRequest
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              onEvent={this.controller.handleEvent}
                              currentTherapists={this.state.currentTherapists}
                              educationList={this.state.educationList}
                              specialtyList={this.state.specialtyList}
                              clinicalTermSet={this.state.clinicalTermSet}
                              employeeDocuments={this.state.employeeDocuments}
                              auditLogList={this.state.auditLogList}
                            />
                          );
                        },
                      },
                      {
                        key: ADMIN_NAME_LIST["รายชื่อนักกายภาพผู้ให้บริการใน MeHealth"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["รายชื่อนักกายภาพผู้ให้บริการใน MeHealth"]}`,
                        }),
                        icon: ADMIN_ICON_LIST["รายชื่อนักกายภาพผู้ให้บริการใน MeHealth"],
                        render: () => {
                          return (
                            <CardPhysiotherapistList
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              onEvent={this.controller.handleEvent}
                              currentTherapists={this.state.currentTherapists}
                              educationList={this.state.educationList}
                              specialtyList={this.state.specialtyList}
                              clinicalTermSet={this.state.clinicalTermSet}
                              employeeDocuments={this.state.employeeDocuments}
                              doctorTherapyDetail={this.state.doctorTherapyDetail}
                              doctorList={this.state.doctorList}
                              doctorTherapyItemDetail={this.state.doctorTherapyItemDetail}
                              doctorTherapyList={this.state.doctorTherapyList}
                              schedulingList={this.state.schedulingList}
                              auditLogList={this.state.auditLogList}
                            />
                          );
                        },
                      },
                      {
                        key: ADMIN_NAME_LIST["รายชื่อสมาชิก OA"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["รายชื่อสมาชิก OA"]}`,
                        }),
                        icon: ADMIN_ICON_LIST["รายชื่อสมาชิก OA"],
                        render: () => {
                          return (
                            <CardOAMemberList
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              onEvent={this.controller.handleEvent}
                              currentTherapists={this.state.currentTherapists}
                            />
                          );
                        },
                      },
                      {
                        key: ADMIN_NAME_LIST["หลักฐานการชำระเงิน"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["หลักฐานการชำระเงิน"]}`,
                        }),
                        icon: ADMIN_ICON_LIST["หลักฐานการชำระเงิน"],
                        render: () => {
                          return (
                            <CardPaymentSlip
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              onEvent={this.controller.handleEvent}
                              appointmentPaymentRelationList={
                                this.state.appointmentPaymentRelationList
                              }
                              userDetail={this.state.userDetail}
                              isPaymentRelation
                            />
                          );
                        },
                      },
                      ["MSK", "MEHEALTH"].includes(CONFIG.COMPANY)
                        ? {
                            key: ADMIN_NAME_LIST.ข้อมูลบุคลากร,
                            name: this.props.intl.formatMessage({
                              id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.ข้อมูลบุคลากร}`,
                            }),
                            icon: ADMIN_ICON_LIST.ข้อมูลบุคลากร,
                            render: () => (
                              <CardEmployeeInfoManagement
                                className="employee-info-management"
                                setProp={this.controller.setProp}
                                onEvent={this.controller.handleEvent}
                                runSequence={this.runSequence}
                                DSPermissionSequence={this.state.DSPermissionSequence}
                                EmployeeDocumentSequence={this.state.EmployeeDocumentSequence}
                                EmployeeHistorySequence={this.state.EmployeeHistorySequence}
                                EmployeeInfoSequence={this.state.EmployeeInfoSequence}
                                EmployeeListSequence={this.state.EmployeeListSequence}
                                EmployeePaymentSequence={this.state.EmployeePaymentSequence}
                                EmployeeSWHSequence={this.state.EmployeeSWHSequence}
                                EmployeeTASequence={this.state.EmployeeTASequence}
                                allDivisionGroup={this.controller.data.allDivisionGroup}
                                changePassword={this.state.changePassword}
                                django={this.state.django}
                                adminMenuDivisions={this.state.adminMenuDivisions}
                                selectedEmployee={this.state.selectedEmployee}
                                buttonLoadCheck={this.state.buttonLoadCheck}
                                errorMessage={this.state.errorMessage}
                                languageUX={this.props.userSelectedLanguage}
                                masterData={this.controller.data.masterData}
                                selectedDivision={this.state.selectedDivision}
                                searchedItemListWithKey={this.state.searchedItemListWithKey}
                                successMessage={this.state.successMessage}
                                masterOptions={this.state.masterOptions}
                              />
                            ),
                          }
                        : {
                            key: ADMIN_NAME_LIST.ข้อมูลบุคลากร,
                            name: this.props.intl.formatMessage({
                              id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.ข้อมูลบุคลากร}`,
                            }),
                            icon: ADMIN_ICON_LIST.ข้อมูลบุคลากร,
                            render: () => (
                              <CardStaffSetting
                                setProp={this.controller.setProp}
                                onEvent={this.controller.handleEvent}
                                runSequence={this.runSequence}
                                // controller
                                controller={this.controller}
                                proxyController={this.proxyController}
                                // data
                                staffList={this.state.staffList}
                                profileUser={this.state.profileUser}
                                changePassword={this.state.changePassword}
                                settingsUser={this.state.settingsUser}
                                profileEmployee={this.state.profileEmployee}
                                profileDivision={this.state.profileDivision}
                                masterData={this.controller.data.masterData}
                                // options
                                masterOptions={this.state.masterOptions}
                                roleOptions={this.state.roleOptions}
                                divisionOptions={this.state.divisionOptions}
                                // CommonInterface
                                buttonLoadCheck={this.state.buttonLoadCheck}
                                errorMessage={this.state.errorMessage}
                                successMessage={this.state.successMessage}
                                // style
                                userEmployeeStyle={{
                                  height: "calc(100dvh - 7.5rem)",
                                  overflow: "auto",
                                }}
                                // config
                                showPassword2={true}
                                pw2CheckTeacherFlag={true}
                                languageUX={this.props.userSelectedLanguage}
                              />
                            ),
                          },
                      {
                        key: ADMIN_NAME_LIST["Training System"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Training System"]}`,
                        }),
                        render: () => (
                          <CardTrainingInfoManagement
                            setProp={this.controller.setProp}
                            onEvent={this.controller.handleEvent}
                            runSequence={this.runSequence}
                            CourseListSequence={this.state.CourseListSequence}
                            SummaryTrainingKPISequence={this.state.SummaryTrainingKPISequence}
                            TrainingKPISettingSequence={this.state.TrainingKPISettingSequence}
                            TrainingManagementSequence={this.state.TrainingManagementSequence}
                            adminMenuDivisions={this.state.adminMenuDivisions}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            errorMessage={this.state.errorMessage}
                            django={this.state.django}
                            languageUX={this.props.userSelectedLanguage}
                            selectedDivision={this.state.selectedDivision}
                            searchedItemListWithKey={this.state.searchedItemListWithKey}
                            masterOptions={this.state.masterOptions}
                            masterData={this.controller.data.masterData}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.Studio,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.Studio}`,
                        }),
                        icon: ADMIN_ICON_LIST.Studio,
                        render: () => (
                          <div className="diag-studio">
                            <Studio
                              apiToken={this.controller.apiToken}
                              ruleListController={this.ruleListController}
                              diagComposerController={this.diagComposerController}
                              onSetState={(state: any) => this.setState({ ...state })}
                              // Didn't really use onGetDivision in the original code
                              // onGetDivision={props.getDivision}
                              division={this.state.selectedDivision?.id || 0}
                              // isVerified={props.isVerified}
                              isVerified={true} // for demo
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.VaccineUpload,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.VaccineUpload}`,
                        }),
                        render: () => (
                          <VaccineUpload
                            onEvent={this.controller.handleEvent}
                            division={this.controller.data.division}
                            vaccineInfo={this.state.VaccineUpload?.vaccineInfo}
                            appointmentList={this.state.VaccineUpload?.appointmentList}
                            generateUserModal={this.state.VaccineUpload?.generateUserModal}
                            generateUserResult={this.state.VaccineUpload?.generateUserResult}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Upload ข้อมูลผู้ใช้สิทธิ"],
                        name: ADMIN_NAME_LIST["Upload ข้อมูลผู้ใช้สิทธิ"],
                        render: () => (
                          <CardUploadPatientCoverage
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            // seq
                            runSequence={this.runSequence}
                            // CommonInterface
                            errorMessage={this.state.errorMessage}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            // data
                            UploadPatientCoverageSequence={this.state.UploadPatientCoverageSequence}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.ตั้งค่ากฏการเบิก,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.ตั้งค่ากฏการเบิก}`,
                        }),
                        render: () => (
                          <CardWithDrawalRules languageUX={this.props.userSelectedLanguage} />
                        ),
                      },
                      // {
                      //   key: "Claim ยา",
                      //   name: "Claim ยา",
                      //   render: () => (
                      //     <div
                      //       style={{
                      //         padding: "10px",
                      //         display: "flex",
                      //         flexDirection: "column",
                      //       }}
                      //     >
                      //       <a
                      //         href={`${HOST}/manage/CLM/drugclaimpattern/`}
                      //         target="_blank"
                      //       >
                      //         D.1 กำหนดรูปแบบการเคลมยา
                      //       </a>
                      //       <a
                      //         href={`${HOST}/manage/CLM/coveragedrugclaimpattern/`}
                      //         target="_blank"
                      //       >
                      //         D.2 ผูกสิทธิกับรูปแบบการเคลมยา
                      //       </a>
                      //       <a
                      //         href={`${HOST}/manage/CLM/question/`}
                      //         target="_blank"
                      //       >
                      //         D.3 กำหนดคำถาม
                      //       </a>
                      //       <a
                      //         href={`${HOST}/manage/core/doctorgroup/`}
                      //         target="_blank"
                      //       >
                      //         D.4 กำหนดกลุ่มแพทย์
                      //       </a>
                      //       <a
                      //         href={`${HOST}/CLM/ModConditionList.qml?for_claim_type=2`}
                      //         target="_blank"
                      //       >
                      //         D.5 กำหนดเงื่อนไขการเบิกยา
                      //       </a>
                      //       <a
                      //         href={`${HOST}/CLM/CardDrugClaimPatternItemList.qml`}
                      //         target="_blank"
                      //       >
                      //         D.6 กำหนดรายละเอียดการเบิกยา
                      //       </a>
                      //       <a
                      //         href={`${HOST}/manage/CLM/coveragedrugclaimpatternforclaimdrug/`}
                      //         target="_blank"
                      //       >
                      //         D.7 ผูกสิทธิกับรูปแบบการเคลมยา สำหรับเพดานเบิกยา
                      //       </a>
                      //       <a
                      //         href={`${HOST}/manage/CLM/claimdrug/`}
                      //         target="_blank"
                      //       >
                      //         D.8 กำหนดเพดานเบิกยา
                      //       </a>
                      //     </div>
                      //   ),
                      // },
                      // {
                      //   key: "Claim เวชภัณฑ์",
                      //   name: "Claim เวชภัณฑ์",
                      //   render: () => (
                      //     <div
                      //       style={{
                      //         padding: "10px",
                      //         display: "flex",
                      //         flexDirection: "column",
                      //       }}
                      //     >
                      //       <a
                      //         href={`${HOST}/manage/CLM/supplyclaimpattern/`}
                      //         target="_blank"
                      //       >
                      //         S.1 กำหนดรูปแบบการเคลมเวชภัณฑ์
                      //       </a>
                      //       <a
                      //         href={`${HOST}/manage/CLM/coveragesupplyclaimpattern/`}
                      //         target="_blank"
                      //       >
                      //         S.2 ผูกสิทธิกับรูปแบบการเคลมเวชภัณฑ์
                      //       </a>
                      //       <a
                      //         href={`${HOST}/manage/CLM/question/`}
                      //         target="_blank"
                      //       >
                      //         S.3 กำหนดคำถาม
                      //       </a>
                      //       <a
                      //         href={`${HOST}/CLM/ModConditionList.qml?for_claim_type=1`}
                      //         target="_blank"
                      //       >
                      //         S.4 กำหนดเงื่อนไขรหัสเบิกเวชภัณฑ์
                      //       </a>
                      //       <a
                      //         href={`${HOST}/manage/CLM/claimsupply/`}
                      //         target="_blank"
                      //       >
                      //         S.5 กำหนดรหัสเบิกเวชภัณฑ์
                      //       </a>
                      //       <a
                      //         href={`${HOST}/manage/MSD/supplyforclaim/`}
                      //         target="_blank"
                      //       >
                      //         S.6 กำหนดหมวดเวชภัณฑ์
                      //       </a>
                      //       <a
                      //         href={`${HOST}/CLM/CardSupplyClaimSupply.qml`}
                      //         target="_blank"
                      //       >
                      //         S.7 ผูกรหัสเบิกกับเวชภัณฑ์
                      //       </a>
                      //       <a
                      //         href={`${HOST}/manage/CLM/maxreimbclaimsupplygroup/`}
                      //         target="_blank"
                      //       >
                      //         S.8
                      //         กำหนดเพดานเบิกแบบหลายรหัสเบิกไม่เกินเพดานที่กำหนด
                      //       </a>
                      //       <a
                      //         href={`${HOST}/manage/CLM/icd9cmbeauty/`}
                      //         target="_blank"
                      //       >
                      //         S.11 กำหนดรายการ Icd9cm เพื่อความสวยงาม
                      //       </a>
                      //       <a
                      //         href={`${HOST}/manage/CLM/overridesupplymode/`}
                      //         target="_blank"
                      //       >
                      //         S.13 เปลี่ยนหมวดเวชภัณฑ์เมื่อสั่งด้วยสิทธิที่ระบุ
                      //       </a>
                      //     </div>
                      //   ),
                      // },
                      // {
                      //   key: "Claim บริการ",
                      //   name: "Claim บริการ",
                      //   render: () => (
                      //     <div
                      //       style={{
                      //         padding: "10px",
                      //         display: "flex",
                      //         flexDirection: "column",
                      //       }}
                      //     >
                      //       <a
                      //         href={`${HOST}/manage/CLM/otherclaimpattern/`}
                      //         target="_blank"
                      //       >
                      //         O.1 กำหนดรูปแบบการเคลมบริการ
                      //       </a>
                      //       <a
                      //         href={`${HOST}/manage/CLM/coverageotherclaimpattern/`}
                      //         target="_blank"
                      //       >
                      //         O.2 ผูกสิทธิกับรูปแบบการเคลมบริการ
                      //       </a>
                      //       <a
                      //         href={`${HOST}/CLM/ModConditionList.qml?for_claim_type=3`}
                      //         target="_blank"
                      //       >
                      //         O.3 กำหนดเงื่อนไขรหัสเบิกบริการ
                      //       </a>
                      //       <a
                      //         href={`${HOST}/manage/CLM/claimother/`}
                      //         target="_blank"
                      //       >
                      //         O.4 กำหนดรหัสเบิกบริการ
                      //       </a>
                      //       <a
                      //         href={`${HOST}/CLM/CardOtherClaimOther.qml`}
                      //         target="_blank"
                      //       >
                      //         O.5 ผูกรหัสเบิกกับบริการ
                      //       </a>
                      //     </div>
                      //   ),
                      // },
                      // {
                      //   key: "Claim common",
                      //   name: "Claim common",
                      //   render: () => (
                      //     <div
                      //       style={{
                      //         padding: "10px",
                      //         display: "flex",
                      //         flexDirection: "column",
                      //       }}
                      //     >
                      //       <a
                      //         href={`${HOST}/manage/CLM/selfreimbproduct/`}
                      //         target="_blank"
                      //       >
                      //         C.1 กำหนดรายการสินค้าที่นำไปตั้งเบิกเอง
                      //       </a>
                      //       <a
                      //         href={`${HOST}/manage/CLM/notreimbproduct/`}
                      //         target="_blank"
                      //       >
                      //         C.2 กำหนดรายการสินค้าห้ามเบิก
                      //       </a>
                      //       <a
                      //         href={`${HOST}/manage/CLM/notreimbicd10/`}
                      //         target="_blank"
                      //       >
                      //         C.3 กำหนดรายการ ICD10 ห้ามเบิก
                      //       </a>
                      //       <a
                      //         href={`${HOST}/manage/CLM/coveragesetting/`}
                      //         target="_blank"
                      //       >
                      //         C.4 ตั้งค่าสิทธิ
                      //       </a>
                      //       <a
                      //         href={`${HOST}/manage/CLM/coverageabsorb/`}
                      //         target="_blank"
                      //       >
                      //         C.5 ตั้งค่า Absorb (โรงพยาบาลรองรับค่าใช้จ่าย)
                      //       </a>
                      //     </div>
                      //   ),
                      // },
                      {
                        key: ADMIN_NAME_LIST.รับชำระเงินต้นสังกัด,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.รับชำระเงินต้นสังกัด}`,
                        }),
                        render: () => (
                          <CardReceiptAr
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            runSequence={this.runSequence}
                            BillPaymentArSequence={this.state.BillPaymentArSequence}
                            masterOptions={this.state.masterOptions}
                            masterData={this.controller.data.masterData}
                            selectedDevice={this.state.selectedDevice}
                            errorMessage={this.state.errorMessage}
                            successMessage={this.state.successMessage}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            searchedItemList={this.state.searchedItemList}
                            // BIL
                            bilReceiptCodeDetail={this.state.bilReceiptCodeDetail}
                            receiptGroupSetting={this.state.receiptGroupSetting}
                            // Medical Fee
                            BillPaymentSequence={this.state.BillPaymentSequence}
                            billingHistorySequence={this.state.BillingHistorySequence}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.รายงานทางการเงิน,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.รายงานทางการเงิน}`,
                        }),
                        render: () => (
                          <CardFinancialReport
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            // seq
                            runSequence={this.runSequence}
                            FinancialReportSequence={this.state.FinancialReportSequence}
                            // options
                            masterOptions={this.state.masterOptions}
                            // CommonInterface
                            errorMessage={this.state.errorMessage}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.รายงานประจำคลินิก,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.รายงานประจำคลินิก}`,
                        }),
                        render: () => (
                          <CardClinicAnnualReport
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            runSequence={this.runSequence}
                            masterOptions={this.state.masterOptions}
                            ClinicAnnualReportSequence={this.state.ClinicAnnualReportSequence}
                            adminMenuDivisions={this.state.adminMenuDivisions}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            selectedDivision={this.state.selectedDivision}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["ออกใบแจ้งหนี้ / ตั้งงวด"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["ออกใบแจ้งหนี้ / ตั้งงวด"]}`,
                        }),
                        render: () => (
                          <CardCreateInvoiceGroup
                            // function
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            drugOrderQueueController={this.drugOrderQueueController}
                            // seq
                            runSequence={this.runSequence}
                            ARInvoiceGroupSequence={this.state.ARInvoiceGroupSequence}
                            // data
                            billtransactionItem={this.state.billtransactionItem}
                            commonBillTransaction={this.state.commonBillTransaction}
                            // options
                            coveragePayerOptions={this.state.coveragePayerOptions}
                            masterOptions={this.state.masterOptions}
                            masterData={this.controller.data.masterData}
                            // CommonInterface
                            errorMessage={this.state.errorMessage}
                            successMessage={this.state.successMessage}
                            searchedItemListWithKey={this.state.searchedItemListWithKey}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            // Medical Fee
                            BillPaymentSequence={this.state.BillPaymentSequence}
                            invoiceItemByModes={this.state.invoiceItemByModes}
                            invoiceItemByOrders={this.state.invoiceItemByOrders}
                            invoiceItemByItems={this.state.invoiceItemByItems}
                            // Bill Report Print
                            billReportPrint={this.state.billReportPrint}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["เตรียมข้อมูล E-Claim"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["เตรียมข้อมูล E-Claim"]}`,
                        }),
                        render: () => (
                          <CardExportEClaimFile
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            // seq
                            runSequence={this.runSequence}
                            ExportEClaimFileSequence={this.state.ExportEClaimFileSequence}
                            SendClaimDownloadZipFileSequence={
                              this.state.SendClaimDownloadZipFileSequence
                            }
                            // controller
                            drugOrderQueueController={this.drugOrderQueueController}
                            // options
                            masterOptions={this.state.masterOptions}
                            // data
                            masterData={this.controller.data.masterData}
                            userTokenize={this.state.userTokenize}
                            // CommonInterface
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            errorMessage={this.state.errorMessage}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["AIPN Send Claim"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["AIPN Send Claim"]}`,
                        }),
                        render: () => (
                          <CardAIPNSendClaim
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            // controller
                            drugOrderQueueController={this.drugOrderQueueController}
                            cardSentClaimInformationController={
                              this.cardSentClaimInformationController
                            }
                            // seq
                            runSequence={this.runSequence}
                            AIPNSendClaimSequence={this.state.AIPNSendClaimSequence}
                            SendClaimDownloadZipFileSequence={
                              this.state.SendClaimDownloadZipFileSequence
                            }
                            // CommonInterface
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            errorMessage={this.state.errorMessage}
                            searchedItemListWithKey={this.state.searchedItemListWithKey}
                            // options
                            masterOptions={this.state.masterOptions}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.บันทึกไฟล์ตอบกลับ,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.บันทึกไฟล์ตอบกลับ}`,
                        }),
                        render: () => (
                          <CardSendClaimResponseFile
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            // seq
                            runSequence={this.runSequence}
                            SendClaimResponseFileSequence={this.state.SendClaimResponseFileSequence}
                            // options
                            coveragePayerOptions={this.state.coveragePayerOptions}
                            // CommonInterface
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            errorMessage={this.state.errorMessage}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["import ค่า Lab สำหรับคำนวณรายได้แพทย์"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["import ค่า Lab สำหรับคำนวณรายได้แพทย์"]}`,
                        }),
                        render: () => (
                          <CardImportLabValuesCalcDoctorFee
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            // seq
                            runSequence={this.runSequence}
                            ImportLabValuesCalcDFSequence={this.state.ImportLabValuesCalcDFSequence}
                            // CommonInterface
                            searchedItemListWithKey={this.state.searchedItemListWithKey}
                            errorMessage={this.state.errorMessage}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.พิมพ์เอกสารภาษี,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.พิมพ์เอกสารภาษี}`,
                        }),
                        render: () => (
                          <CardClaimTaxDocument
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            errorMessage={this.state.errorMessage}
                            // seq
                            runSequence={this.runSequence}
                            ClaimTaxDocumentSequence={this.state.ClaimTaxDocumentSequence}
                            // common
                            // options
                            masterOptions={this.state.masterOptions}
                            masterData={this.controller.data.masterData}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.สรุปค่าตอบแทนแพทย์,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.สรุปค่าตอบแทนแพทย์}`,
                        }),
                        hide: CONFIG.HIDE_DOCTOR_FEE_ALL_MENU, // 67071 hide
                        render: () => (
                          <CardDoctorFeeSummary
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            // seq
                            runSequence={this.runSequence}
                            DoctorFeeSummarySequence={this.state.DoctorFeeSummarySequence}
                            // CommonInterface
                            searchedItemListWithKey={this.state.searchedItemListWithKey}
                            errorMessage={this.state.errorMessage}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            successMessage={this.state.successMessage}
                            // options
                            masterOptions={this.state.masterOptions}
                            masterData={this.controller.data.masterData}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.ศูนย์ต้นทุนรายใบเสร็จ,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.ศูนย์ต้นทุนรายใบเสร็จ}`,
                        }),
                        render: () => (
                          <CardCostCenterReceipt
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            // seq
                            runSequence={this.runSequence}
                            CostCenterReceiptSequence={this.state.CostCenterReceiptSequence}
                            // common
                            // options
                            masterOptions={this.state.masterOptions}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.รายงานบัญชี,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.รายงานบัญชี}`,
                        }),
                        render: () => (
                          <CardSapAccountingReport
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            // seq
                            runSequence={this.runSequence}
                            SapAccountingReportSequence={this.state.SapAccountingReportSequence}
                            // common
                            // options
                            masterOptions={this.state.masterOptions}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["OPD Claim Resolve"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["OPD Claim Resolve"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardOPDClaimResolve languageUX={this.props.userSelectedLanguage} />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["OPD AR Transaction"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["OPD AR Transaction"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardCreateARTransactionContainer
                              apiToken={this.controller.apiToken}
                              tableStyle={{
                                width: "calc(100vw - 180px)",
                                height: "calc(100vh - 29rem)",
                              }}
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["ตรวจสอบรายการสินค้าและบริการ"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["ตรวจสอบรายการสินค้าและบริการ"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardSupplyServiceChecking
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // data
                              // apiToken={this.controller.apiToken}
                              // seq
                              runSequence={this.runSequence}
                              SupplyServiceCheckingSequence={
                                this.state.SupplyServiceCheckingSequence
                              }
                              // common
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              // options
                              masterOptions={this.state.masterOptions}
                              language={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["OPD รายการที่สร้างเลขงวดแล้ว"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["OPD รายการที่สร้างเลขงวดแล้ว"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardOPDDownloadSentClaimFile
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // controller
                              cardSentClaimInformationController={
                                this.cardSentClaimInformationController
                              }
                              // seq
                              runSequence={this.runSequence}
                              DownloadSentClaimFileSequence={
                                this.state.DownloadSentClaimFileSequence
                              }
                              // data
                              apiToken={this.controller.apiToken}
                              // CommonInterface
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              // options
                              masterOptions={this.state.masterOptions}
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["OPD Send Claim"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["OPD Send Claim"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardUploadSentClaimResponseFile
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["IPD AR Transaction"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["IPD AR Transaction"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardCreateARTransaction
                              cardTitle={"สร้างเลขตั้งเบิกให้กับผู้ป่วยใน"}
                              languageUX={this.props.userSelectedLanguage}
                              // controller={this.createARTransactionController}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["IPD Send Claim Info"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["IPD Send Claim Info"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardSentClaimInformation
                              // controller={this.sentClaimInfoController}
                              onEvent={this.controller.handleEvent}
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["IPD Send Claim Result"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["IPD Send Claim Result"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardUploadSentClaimResult
                              // controller={this.uploadSentClaimResultController}
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Trigger/Resend BillingPYINF"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Trigger/Resend BillingPYINF"]}`,
                        }),
                        render: () => (
                          <CardBillingPYInterface
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            // seq
                            runSequence={this.runSequence}
                            // CommonInterface
                            errorMessage={this.state.errorMessage}
                            successMessage={this.state.successMessage}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            // data
                            BillingPYInterfaceSequence={this.state.BillingPYInterfaceSequence}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Trigger/Resend BillingBLINF"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Trigger/Resend BillingBLINF"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardBillingBLInterface
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // seq
                              runSequence={this.runSequence}
                              BillingBLInterfaceSequence={this.state.BillingBLInterfaceSequence}
                              // common
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              successMessage={this.state.successMessage}
                              // options
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Trigger/Resend DischargeINF"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Trigger/Resend DischargeINF"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardTriggerDischargeInterface
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // data
                              // apiToken={this.controller.apiToken}
                              // seq
                              runSequence={this.runSequence}
                              TriggerDischargeInterfaceSequence={
                                this.state.TriggerDischargeInterfaceSequence
                              }
                              // common
                              searchedItemListWithKey={this.state.searchedItemListWithKey}
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              successMessage={this.state.successMessage}
                              // options
                              masterOptions={this.state.masterOptions}
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Trigger/Resend DrugTransferINF"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Trigger/Resend DrugTransferINF"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardDrugTransferInterface
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // seq
                              runSequence={this.runSequence}
                              DrugTransferInterfaceSequence={
                                this.state.DrugTransferInterfaceSequence
                              }
                              // common
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              successMessage={this.state.successMessage}
                              // options
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Trigger/Resend DrugDispensingINF"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Trigger/Resend DrugDispensingINF"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardDrugDispensingInterface
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // seq
                              runSequence={this.runSequence}
                              DrugDispensingInterfaceSequence={
                                this.state.DrugDispensingInterfaceSequence
                              }
                              // common
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              successMessage={this.state.successMessage}
                              // options
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Trigger Invoiceitem (BillingINF)"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Trigger Invoiceitem (BillingINF)"]}`,
                        }),
                        render: () => (
                          <CardTriggerInvoiceitem
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            // seq
                            runSequence={this.runSequence}
                            // CommonInterface
                            errorMessage={this.state.errorMessage}
                            successMessage={this.state.successMessage}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            masterOptions={this.state.masterOptions}
                            // data
                            TriggerInvoiceitemSequence={this.state.TriggerInvoiceitemSequence}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Trigger Operating Order (DFINF)"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Trigger Operating Order (DFINF)"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardOperatingOrderInterface
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // seq
                              runSequence={this.runSequence}
                              OperatingOrderInterfaceSequence={
                                this.state.OperatingOrderInterfaceSequence
                              }
                              // common
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              successMessage={this.state.successMessage}
                              // options
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Trigger DoctorFee Order (DFINF)"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Trigger DoctorFee Order (DFINF)"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardDoctorFeeOrderInterface
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // seq
                              runSequence={this.runSequence}
                              DoctorFeeOrderInterfaceSequence={
                                this.state.DoctorFeeOrderInterfaceSequence
                              }
                              // common
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              successMessage={this.state.successMessage}
                              // options
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Trigger Lab Order (DFINF)"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Trigger Lab Order (DFINF)"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardLabOrderInterface
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // seq
                              runSequence={this.runSequence}
                              LabOrderInterfaceSequence={this.state.LabOrderInterfaceSequence}
                              // common
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              successMessage={this.state.successMessage}
                              // options
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Trigger/Resend PatientRecordINF"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Trigger/Resend PatientRecordINF"]}`,
                        }),
                        render: () => (
                          <CardPatientRecordInterface
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            // seq
                            runSequence={this.runSequence}
                            // CommonInterface
                            errorMessage={this.state.errorMessage}
                            successMessage={this.state.successMessage}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            // data
                            PatientRecordInterfaceSequence={
                              this.state.PatientRecordInterfaceSequence
                            }
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Trigger Imaging Order (DFINF)"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Trigger Imaging Order (DFINF)"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardImagingOrderInterface
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // seq
                              runSequence={this.runSequence}
                              ImagingOrderInterfaceSequence={
                                this.state.ImagingOrderInterfaceSequence
                              }
                              // common
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              successMessage={this.state.successMessage}
                              masterOptions={this.state.masterOptions}
                              // options
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Trigger Treatment Order (DFINF)"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Trigger Treatment Order (DFINF)"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardTreatmentOrderInterface
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // seq
                              runSequence={this.runSequence}
                              TreatmentOrderInterfaceSequence={
                                this.state.TreatmentOrderInterfaceSequence
                              }
                              // common
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              successMessage={this.state.successMessage}
                              masterOptions={this.state.masterOptions}
                              // options
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Trigger/Resend DFINF"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Trigger/Resend DFINF"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardDFInterface
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // seq
                              runSequence={this.runSequence}
                              DFInterfaceSequence={this.state.DFInterfaceSequence}
                              // common
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              successMessage={this.state.successMessage}
                              // options
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Edit Division Supply Order"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Edit Division Supply Order"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardEditDivisionSupplyOrder
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // seq
                              runSequence={this.runSequence}
                              EditDivisionSupplyOrderSequence={
                                this.state.EditDivisionSupplyOrderSequence
                              }
                              // common
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              successMessage={this.state.successMessage}
                              masterOptions={this.state.masterOptions}
                              // options
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Generate Outbound (By Freeze Time)"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Generate Outbound (By Freeze Time)"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardGenerateOutboundFreezeTime
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // seq
                              runSequence={this.runSequence}
                              GenerateOutboundFreezeTimeSequnce={
                                this.state.GenerateOutboundFreezeTimeSequence
                              }
                              // common
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              successMessage={this.state.successMessage}
                              // options
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Generate Drug Continue (By Date)"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Generate Drug Continue (By Date)"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardGenerateContinueByDate
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // seq
                              runSequence={this.runSequence}
                              GenerateContinueByDateSequnce={
                                this.state.GenerateContinueByDateSequence
                              }
                              // common
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              successMessage={this.state.successMessage}
                              // options
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Generate Drug Continue (Plan Item)"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Generate Drug Continue (Plan Item)"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardGenerateContinueByPlan
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // seq
                              runSequence={this.runSequence}
                              GenerateContinueByPlanSequence={
                                this.state.GenerateContinueByPlanSequence
                              }
                              // common
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              successMessage={this.state.successMessage}
                              masterOptions={this.state.masterOptions}
                              // options
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Add NED To Drug Order Item"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Add NED To Drug Order Item"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardAddNedDrugOrderItem
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // seq
                              runSequence={this.runSequence}
                              AddNedDrugOrderItemSequence={this.state.AddNedDrugOrderItemSequence}
                              // common
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              successMessage={this.state.successMessage}
                              masterOptions={this.state.masterOptions}
                              // options
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Payroll"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Payroll"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardPayroll
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // seq
                              runSequence={this.runSequence}
                              PayrollSequence={this.state.PayrollSequence}
                              adminMenuDivisions={this.state.adminMenuDivisions}
                              masterOptions={this.state.masterOptions}
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              successMessage={this.state.successMessage}
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Work Schedule"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Work Schedule"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardWorkSchedule
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // seq
                              runSequence={this.runSequence}
                              SetupWorkScheduleSequence={this.state.SetupWorkScheduleSequence}
                              CourseListSequence={this.state.CourseListSequence}
                              EmployeeSWHSequence={this.state.EmployeeSWHSequence}
                              EmployeeTASequence={this.state.EmployeeTASequence}
                              TrainingManagementSequence={this.state.TrainingManagementSequence}
                              WorkScheduleSequence={this.state.WorkScheduleSequence}
                              adminMenuDivisions={this.state.adminMenuDivisions}
                              // common
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              successMessage={this.state.successMessage}
                              selectedDivision={this.state.selectedDivision}
                              searchedItemListWithKey={this.state.searchedItemListWithKey}
                              masterData={this.controller.data.masterData}
                              masterOptions={this.state.masterOptions}
                              django={this.state.django}
                              // options
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Leave Policy"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Leave Policy"]}`,
                        }),
                        render: () => (
                          <CardLeavePolicy
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            // seq
                            runSequence={this.runSequence}
                            LeavePolicySeqeunce={this.state.LeavePolicySequence}
                            // common
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            errorMessage={this.state.errorMessage}
                            successMessage={this.state.successMessage}
                            // options
                            masterOptions={this.state.masterOptions}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Self Service & Time Schedule"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Self Service & Time Schedule"]}`,
                        }),
                        render: () => (
                          <CardSelfServiceSchedule
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            // seq
                            runSequence={this.runSequence}
                            SelfServiceScheduleSequence={this.state.SelfServiceScheduleSequence}
                            EmployeeTASequence={this.state.EmployeeTASequence}
                            SetupWorkScheduleSequence={this.state.SetupWorkScheduleSequence}
                            TrainingHistorySequence={this.state.TrainingHistorySequence}
                            PaySlipSequence={this.state.PaySlipSequence}
                            // options
                            userProfile={this.controller.data?.userProfile}
                            selectedDivision={this.state.selectedDivision}
                            searchedItemListWithKey={this.state.searchedItemListWithKey}
                            adminMenuDivisions={this.state.adminMenuDivisions}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            errorMessage={this.state.errorMessage}
                            successMessage={this.state.successMessage}
                            masterData={this.controller.data.masterData}
                            masterOptions={this.state.masterOptions}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Work & Plan System"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Work & Plan System"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardWorkPlan
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // seq
                              runSequence={this.runSequence}
                              ProjectListSequence={this.state.ProjectListSequence}
                              IssueListSequence={this.state.IssueListSequence}
                              // common
                              adminMenuDivisions={this.state.adminMenuDivisions}
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              successMessage={this.state.successMessage}
                              selectedDivision={this.state.selectedDivision}
                              masterOptions={this.state.masterOptions}
                              // options
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.จัดการตารางห้องผ่าตัด,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.จัดการตารางห้องผ่าตัด}`,
                        }),
                        render: () => (
                          <div>
                            <CardManageOperatingRoom
                              // callback
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              runSequence={this.runSequence}
                              // data
                              ManageORSequence={this.state.ManageORSequence}
                              errorMessage={this.state.errorMessage}
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Anesthesia Template"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Anesthesia Template"]}`,
                        }),
                        render: () => (
                          <div>
                            <CardSetupAnesthesiaTemplate
                              // function
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // CommonInterface
                              errorMessage={this.state.errorMessage}
                              successMessage={this.state.successMessage}
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              masterOptions={this.state.masterOptions}
                              drugSearchLoading={this.state.drugSearchLoading}
                              drugSearchResult={this.state.drugSearchResult}
                              drugSearchText={this.state.drugSearchText}
                              // seq
                              runSequence={this.runSequence}
                              AnesTemplateSequence={this.state.AnesTemplateSequence}
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Segment tool"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Segment tool"]}`,
                        }),
                        render: () => {
                          return (
                            <TabPenta
                              languageUX={this.props.userSelectedLanguage}
                              selectedTabIndex={0}
                              key={"segment"}
                              tabWidth="125px"
                              data={[
                                {
                                  key: "Underlying disease",
                                  name: "Underlying disease",
                                  render: () => (
                                    <CardUnderlyingDisease
                                      onEvent={this.controller.handleEvent}
                                      setProp={this.controller.setProp}
                                      // controller
                                      drugOrderQueueController={this.drugOrderQueueController}
                                      // seq
                                      runSequence={this.runSequence}
                                      UnderlyingDiseaseSequence={
                                        this.state.UnderlyingDiseaseSequence
                                      }
                                      // CommonInterface
                                      errorMessage={this.state.errorMessage}
                                      buttonLoadCheck={this.state.buttonLoadCheck}
                                      languageUX={this.props.userSelectedLanguage}
                                    />
                                  ),
                                },
                                {
                                  key: "Risk Alert",
                                  name: "Risk Alert",
                                  render: () => (
                                    <CardSegment
                                      // function
                                      onEvent={this.controller.handleEvent}
                                      setProp={this.controller.setProp}
                                      // CommonInterface
                                      errorMessage={this.state.errorMessage}
                                      successMessage={this.state.successMessage}
                                      buttonLoadCheck={this.state.buttonLoadCheck}
                                      // seq
                                      runSequence={this.runSequence}
                                      SegmentSequence={this.state.SegmentSequence}
                                      // controller
                                      drugOrderQueueController={this.drugOrderQueueController}
                                    />
                                  ),
                                },
                                {
                                  key: "Drug-Disease interaction",
                                  name: "Drug-Disease interaction",
                                  render: () => (
                                    <>
                                      <CardDrugDiseaseInteraction
                                        onEvent={this.controller.handleEvent}
                                        setProp={this.controller.setProp}
                                        // seq
                                        runSequence={this.runSequence}
                                        DrugDiseaseInteractionSequence={
                                          this.state.DrugDiseaseInteractionSequence
                                        }
                                        // CommonInterface
                                        errorMessage={this.state.errorMessage}
                                        buttonLoadCheck={this.state.buttonLoadCheck}
                                        searchedItemListWithKey={this.state.searchedItemListWithKey}
                                        // options
                                        masterOptions={this.state.masterOptions}
                                        languageUX={this.props.userSelectedLanguage}
                                      />
                                    </>
                                  ),
                                },
                                {
                                  key: "Health Member",
                                  name: "Health Member",
                                  render: () => (
                                    <CardHealthMember
                                      onEvent={this.controller.handleEvent}
                                      setProp={this.controller.setProp}
                                      // seq
                                      runSequence={this.runSequence}
                                      HealthMemberSequence={this.state.HealthMemberSequence}
                                      // controller
                                      drugOrderQueueController={this.drugOrderQueueController}
                                      // CommonInterface
                                      errorMessage={this.state.errorMessage}
                                      buttonLoadCheck={this.state.buttonLoadCheck}
                                      searchedItemListWithKey={this.state.searchedItemListWithKey}
                                      languageUX={this.props.userSelectedLanguage}
                                    />
                                  ),
                                },
                              ]}
                              setProp={this.controller.setProp}
                            />
                          );
                        },
                      },
                      // {
                      //   key: "รีวิว",
                      //   name: "รีวิว",
                      //   render: () =>
                      //     <div>
                      //       <ARReview
                      //         onEvent={context.controller.handleEvent}
                      //         setProp={context.controller.setProp}
                      //         setState={context.controller.setState}
                      //         encounterInfo={this.state.encounterInfo}
                      //         claimStatusOpd={this.state.claimStatusOpd}
                      //         claimStatusIpd={this.state.claimStatusIpd}
                      //         claimTaskOPDList={this.state.claimTaskOPDList}
                      //         claimTaskOPDAmountIndex={this.state.claimTaskOPDAmountIndex}
                      //         claimTaskOPDInvoiceIndex={this.state.claimTaskOPDInvoiceIndex}
                      //         claimTaskIPDList={this.state.claimTaskIPDList}
                      //         claimTaskIPDDateIndex={this.state.claimTaskIPDDateIndex}
                      //         claimTaskIPDInvoiceIndex={this.state.claimTaskIPDInvoiceIndex}
                      //     />
                      //     </div>
                      // },
                      // {
                      //   key: "Data Science",
                      //   name: "Data Science",
                      //   render: () =>
                      //     <div>
                      //       <DataScience
                      //       onEvent={context.controller.handleEvent}
                      //       encounterStat={this.state.encounterStat}
                      //       diagnosisStat={this.state.diagnosisStat}
                      //       orderStat={this.state.orderStat}
                      //       labStat={this.state.labStat}
                      //     />
                      //     </div>
                      // },
                      {
                        key: ADMIN_NAME_LIST.Debug,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.Debug}`,
                        }),
                        render: () => (
                          <Debug
                            onEvent={this.controller.handleEvent}
                            debugInfo={this.state.debugInfo}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Upload by template"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Upload by template"]}`,
                        }),
                        render: () => (
                          <CardUploadTemplateExcel
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            errorMessage={this.state.errorMessage}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            successMessage={this.state.successMessage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.MeForm,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.MeForm}`,
                        }),
                        icon: ADMIN_ICON_LIST.MeForm,
                        render: () => (
                          <CardMeFormMain
                            MeFormSequence={this.state.MeFormSequence}
                            runSequence={this.runSequence}
                            setProp={this.controller.setProp}
                            selectedDivisionId={this.state.selectedDivision?.id}
                            languageUX={this.props.userSelectedLanguage}
                            // common
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            successMessage={this.state.successMessage}
                            errorMessage={this.state.errorMessage}
                            loadingStatus={this.state.loadingStatus}
                            // ischart
                            controller={this.controller}
                            loggedin={this.state.loggedin}
                            userProfile={this.state.userProfile}
                            selectedDivision={this.state.selectedDivision}
                            // change tab
                            onGotoMeCast={() => {
                              this.tabAdminRef.changeTabKey(ADMIN_NAME_LIST.MeCast);
                              this.setState({ MeCastDefaultTabIndex: 1 });
                            }}
                            // buy credit
                            BillingCreditWallet={this.state.BillingCreditWallet}
                            onEvent={this.controller.handleEvent}
                            BillingAndPackageSequence={this.state.BillingAndPackageSequence}
                            BillingCarts={this.state.BillingCarts}
                            onHistoryClick={() => console.log("Open history modal")}
                            onProceed={() => {
                              this.setState({
                                BillingAndPackageSequence: {
                                  ...this.state.BillingAndPackageSequence,
                                  openTransactionModal: true,
                                  isBroadcast: true,
                                },
                              });
                            }}
                            termsAndConditionsList={this.state.termsAndConditionsList}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.MeCast,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.MeCast}`,
                        }),
                        icon: ADMIN_ICON_LIST.MeCast,
                        render: () => (
                          <CardMeCastMain
                            MeCastSequence={this.state.MeCastSequence}
                            runSequence={this.runSequence}
                            setProp={this.controller.setProp}
                            selectedDivisionId={this.state.selectedDivision?.id}
                            languageUX={this.props.userSelectedLanguage}
                            // common
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            successMessage={this.state.successMessage}
                            errorMessage={this.state.errorMessage}
                            loadingStatus={this.state.loadingStatus}
                            BillingCreditWallet={this.state.BillingCreditWallet}
                            userProfile={this.state.userProfile}
                            selectedDivision={this.state.selectedDivision}
                            // config
                            defaultTabIndex={this.state.MeCastDefaultTabIndex}
                            // buy credit
                            onEvent={this.controller.handleEvent}
                            BillingAndPackageSequence={this.state.BillingAndPackageSequence}
                            BillingCarts={this.state.BillingCarts}
                            controller={this.controller}
                            onHistoryClick={() => console.log("Open history modal")}
                            onProceed={() => {
                              this.setState({
                                BillingAndPackageSequence: {
                                  ...this.state.BillingAndPackageSequence,
                                  openTransactionModal: true,
                                  isBroadcast: true,
                                },
                              });
                            }}
                            termsAndConditionsList={this.state.termsAndConditionsList}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.Target,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.Target}`,
                        }),
                        icon: ADMIN_ICON_LIST.Target,
                        render: () => (
                          <CardSegmentTargetManage
                            SegmentTargetSequence={this.state.SegmentTargetSequence}
                            runSequence={this.runSequence}
                            setProp={this.controller.setProp}
                            selectedDivisionId={this.state.selectedDivision?.id}
                            userId={this.controller.data.user}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.สรุปนัดหมาย,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.สรุปนัดหมาย}`,
                        }),
                        icon: ADMIN_ICON_LIST.สรุปนัดหมาย,
                        render: () => (
                          <CardAppointmentSummary
                            // main control
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            proxyController={this.proxyController}
                            runSequence={this.runSequence}
                            searchedItemList={this.state.searchedItemList}
                            masterOptions={this.state.masterOptions}
                            masterData={this.controller.data.masterData}
                            loadingStatus={this.state.loadingStatus}
                            errorMessage={this.state.errorMessage}
                            successMessage={this.state.successMessage}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            // config
                            hideDrugAllergy
                            // handle check
                            titleName="สรุปนัดหมาย"
                            waitingList={this.state.waitingList}
                            blockList={this.state.blockList}
                            availableSlots={this.state.availableSlots}
                            selectedPatient={this.state.selectedPatient}
                            selectedAppointment={this.state.selectedAppointment}
                            selectedDivision={this.state.selectedDivision}
                            selectedBlock={this.state.selectedBlock}
                            selectedEncounter={this.state.selectedEncounter}
                            selectedEmr={this.state.selectedEmr}
                            selectedProgressCycle={this.state.selectedProgressCycle}
                            searchedItemListWithKey={this.state.searchedItemListWithKey}
                            patientAppType={this.state.masterOptions?.patientAppType}
                            appointmentSummaryList={this.state.appointmentSummaryList}
                            appointmentSummaryPage={this.state.appointmentSummaryPage}
                            loadingFilterAppList={this.state.loadingFilterAppList}
                            loadingPrintAppList={this.state.loadingPrintAppList}
                            chairList={this.state.chairList}
                            divisionList={this.state.divisionList}
                            allDivisionDict={this.controller.data.allDivisionDict}
                            userTokenize={this.state.userTokenize}
                            preOrderList={this.state.preOrderList}
                            duplicateAppointment={this.state.duplicateAppointment}
                            reoccureDuplicateAppointment={this.state.reoccureDuplicateAppointment}
                            django={this.state.django}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Printer list"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Printer list"]}`,
                        }),
                        render: () => <CardPrinterList />,
                      },
                      {
                        key: ADMIN_NAME_LIST["Order Set Template"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Order Set Template"]}`,
                        }),
                        render: () => (
                          <CardOrderSetTemplate
                            runSequence={this.runSequence}
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            successMessage={this.state.successMessage}
                            errorMessage={this.state.errorMessage}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            OrderSetTemplateSequence={this.state.OrderSetTemplateSequence}
                            masterOptions={this.state.masterOptions}
                            masterData={this.controller.data.masterData}
                            searchedItemList={this.state.searchedItemList}
                            searchedItemListWithKey={this.state.searchedItemListWithKey}
                            supplyOrderEligibilityOptions={this.state.supplyOrderEligibilityOptions}
                            adminMenuDivisions={this.state.adminMenuDivisions}
                            selectedDivision={this.state.selectedDivision}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Billing & Package"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["Billing & Package"]}`,
                        }),
                        icon: ADMIN_ICON_LIST["Billing & Package"],
                        render: () => (
                          <CardBuyBillingPackage
                            runSequence={this.runSequence}
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            languageUX={this.props.userSelectedLanguage}
                            BillingAndPackageSequence={this.state.BillingAndPackageSequence}
                            BillingCarts={this.state.BillingCarts}
                            BillingCreditWallet={this.state.BillingCreditWallet}
                            controller={this.controller}
                            onHistoryClick={() => console.log("Open history modal")}
                            onProceed={() => {
                              this.setState({
                                BillingAndPackageSequence: {
                                  ...this.state.BillingAndPackageSequence,
                                  openTransactionModal: true,
                                },
                              });
                            }}
                            termsAndConditionsList={this.state.termsAndConditionsList}
                            errorMessage={this.state.errorMessage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["ทำนัดหมาย"],
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST["ทำนัดหมาย"]}`,
                        }),
                        icon: ADMIN_ICON_LIST["ทำนัดหมาย"],
                        render: () => (
                          <CardMakeAppointmentMeHey
                            controller={this.controller}
                            runSequence={this.runSequence}
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            languageUX={this.props.userSelectedLanguage}
                            MakeAppointmentMeHeySequence={this.state.MakeAppointmentMeHeySequence}
                            searchedItemListWithKey={this.state.searchedItemListWithKey}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.รายชื่อผู้นัดหมาย,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.รายชื่อผู้นัดหมาย}`,
                        }),
                        icon: ADMIN_ICON_LIST.รายชื่อผู้นัดหมาย,
                        render: () => (
                          <CardAppointmentListMEH
                            controller={this.controller}
                            runSequence={this.runSequence}
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            AppointmentListMEHSequence={this.state.AppointmentListMEHSequence}
                            MakeAppointmentMeHeySequence={this.state.MakeAppointmentMeHeySequence}
                            searchedItemListWithKey={this.state.searchedItemListWithKey}
                            divisionId={this.state.selectedDivision?.id}
                            availableSlots={this.state.availableSlots}
                            userTokenize={this.state.userTokenize}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            errorMessage={this.state.errorMessage}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.Affiliate,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.Affiliate}`,
                        }),
                        icon: ADMIN_ICON_LIST.Affiliate,
                        render: () => (
                          <CardAffiliateCommission
                            runSequence={this.runSequence}
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            AffiliateCommissionSequence={this.state.AffiliateCommissionSequence}
                            AffiliateSettingsSequence={this.state.AffiliateSettingsSequence}
                            searchedItemListWithKey={this.state.searchedItemListWithKey}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            errorMessage={this.state.errorMessage}
                            masterData={this.controller.data.masterData}
                            masterOptions={this.state.masterOptions}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.MePOS,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.MePOS}`,
                        }),
                        icon: ADMIN_ICON_LIST.MePOS,
                        render: () => (
                          <CardMeBillingMain
                            controller={this.controller}
                            runSequence={this.runSequence}
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            MeGenSequence={this.state.MeGenSequence}
                            BillingAndPackageSequence={this.state.BillingAndPackageSequence}
                            goToMeGen={this.state.goToMeGen}
                            phlebotomyQueue={this.state.phlebotomyQueue}
                            meBillingActiveTab={this.state.meBillingActiveTab}
                            meBillingInitialMenu={this.state.meBillingInitialMenu}
                            MeBillingSequence={this.state.MeBillingSequence}
                            SaveServiceOrderSequence={this.state.SaveServiceOrderSequence}
                            divisionType={this.state.divisionType}
                            // medicalfee
                            patientInfo={this.state.selectedPatient}
                            selectedEncounter={this.state.selectedEncounter}
                            invoiceItemByModes={this.state.invoiceItemByModes}
                            invoiceItemByOrders={this.state.invoiceItemByOrders}
                            invoiceItemByItems={this.state.invoiceItemByItems}
                            patientOrders={this.state.patientOrders}
                            refundOrders={this.state.refundOrders}
                            medicalFeeFilter={this.state.medicalFeeFilter}
                            patientEncounterLockerStatus={this.state.patientEncounterLockerStatus}
                            encounterSuspension={this.state.encounterSuspension}
                            BillPaymentSequence={this.state.BillPaymentSequence}
                            taskTrackingList={this.state.taskTrackingList}
                            billPendingDetail={this.state.billPendingDetail}
                            bilReceiptCodeDetail={this.state.bilReceiptCodeDetail}
                            billReportPrint={this.state.billReportPrint}
                            faxClaimItemList={this.state.faxClaimItemList}
                            invoiceItemPackageList={this.state.invoiceItemPackageList}
                            billingPatientLanguage={this.state.billingPatientLanguage}
                            qrCodePayment={this.state.qrCodePayment}
                            // medicalfee history
                            MedicalFeeHistorySequence={this.state.MedicalFeeHistorySequence}
                            // common
                            languageUX={this.props.userSelectedLanguage}
                            masterOptions={this.state.masterOptions}
                            masterData={this.controller.data.masterData}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            successMessage={this.state.successMessage}
                            errorMessage={this.state.errorMessage}
                            loadingStatus={this.state.loadingStatus}
                            selectedDivision={this.state.selectedDivision}
                            searchedItemListWithKey={this.state.searchedItemListWithKey}
                            userProfile={this.state.userProfile}
                            // payment summary
                            PaymentSummarySequence={this.state.PaymentSummarySequence}
                            // payment history
                            PaymentHistorySequence={this.state.PaymentHistorySequence}
                            // package
                            PackagePurchaseSequence={this.state.PackagePurchaseSequence}
                            PackageOrderSequence={this.state.PackageOrderSequence}
                            // lab order
                            django={this.state.django}
                            selectedLabOrderWorking={this.state.selectedLabOrderWorking}
                            selectedContainer={this.state.selectedContainer}
                            selectedLabOrderItem={this.state.selectedLabOrderItem}
                            selectedLabOrderItemChild={this.state.selectedLabOrderItemChild}
                            labOrderItems={this.state.labOrderItems}
                            specimenLogs={this.state.specimenLogs}
                            specimenCollectorMasterData={this.state.specimenCollectorMasterData}
                            labOrderQueue={this.state.labOrderQueue}
                            // lab result
                            LabReportSequence={this.state.LabReportSequence}
                            // lab summary
                            OPDLabSummarySequence={this.state.OPDLabSummarySequence}
                            permissionLabResultConfidential={
                              this.state.permissionLabResultConfidential
                            }
                            selectedPatient={this.state.selectedPatient}
                            centralLabResultList={this.state.centralLabResultList}
                            // appointment
                            MakeAppointmentMeHeySequence={this.state.MakeAppointmentMeHeySequence}
                            // patient queue
                            PatientQueueSequence={this.state.PatientQueueSequence}
                            // print list
                            printListController={this.printListController}
                            // scanner
                            scannedDocumentController={this.scannedDocumentController}
                            patientData={this.state.patientData}
                            // shared lab result
                            SharedLabResultSequence={this.state.SharedLabResultSequence}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.รายการบริการ,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.รายการบริการ}`,
                        }),
                        icon: ADMIN_ICON_LIST.รายการบริการ,
                        render: () => (
                          <CardSettingService
                            runSequence={this.runSequence}
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            SaveServiceOrderSequence={this.state.SaveServiceOrderSequence}
                            controller={this.controller}
                            // common
                            loadingStatus={this.state.loadingStatus}
                            errorMessage={this.state.errorMessage}
                            successMessage={this.state.successMessage}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            selectedDivision={this.state.selectedDivision}
                            userTokenize={this.state.userTokenize}
                            masterOptions={this.state.masterOptions}
                            masterData={this.controller.data.masterData}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["Setting Package Lab"],
                        name: ADMIN_NAME_LIST["Setting Package Lab"],
                        render: () => (
                          <CardMeSettingPackage
                            setProp={this.controller.setProp}
                            onEvent={this.controller.handleEvent}
                            // seq
                            runSequence={this.runSequence}
                            SettingPackageSequence={this.state.SettingPackageSequence}
                            // CommonInterface
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            errorMessage={this.state.errorMessage}
                            searchedItemListWithKey={this.state.searchedItemListWithKey}
                            // options
                            masterOptions={this.state.masterOptions}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.MeWeb,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.MeWeb}`,
                        }),
                        icon: ADMIN_ICON_LIST.MeWeb,
                        render: () => (
                          <ClinicCMS
                            divisionId={this.state.selectedDivision?.id}
                            apiToken={this.controller.apiToken}
                            apiBaseUrl={CONFIG.API_HOST}
                            lineLiffId={CONFIG.MOBILE_LINE_LIFF_ID}
                            officialAccountId={this.state.officialAccountDetail?.id}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.MeScript,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.MeScript}`,
                        }),
                        icon: ADMIN_ICON_LIST.MeScript,
                        render: () => (
                          <CardMeScriptMain
                            runSequence={this.runSequence}
                            MeScriptSequence={this.state.MeScriptSequence}
                            setProp={this.controller.setProp}
                            // common
                            errorMessage={this.state.errorMessage}
                            successMessage={this.state.successMessage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.MeGen,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.MeGen}`,
                        }),
                        icon: ADMIN_ICON_LIST.MeGen,
                        keepMounted: true,
                        render: () => (
                          <CardMeGenMain
                            MeGenSequence={this.state.MeGenSequence}
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            // apiToken={this.controller.apiToken}
                            // common
                            errorMessage={this.state.errorMessage}
                            successMessage={this.state.successMessage}
                            loadingStatus={this.state.loadingStatus}
                            selectedDivision={this.state.selectedDivision}
                            canViewAiUsage={canViewMeGenCost}
                            runSequence={this.runSequence}
                            BillingAndPackageSequence={this.state.BillingAndPackageSequence}
                            selectedDivisionId={this.state.selectedDivision?.id}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.MeGenCost,
                        name: this.props.intl.formatMessage({id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.MeGenCost}`}),
                        icon: ADMIN_ICON_LIST.MeGenCost,
                        render: () => (
                          <CardMeGenCostMain
                            MeGenSequence={this.state.MeGenSequence}
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            // common
                            errorMessage={this.state.errorMessage}
                            successMessage={this.state.successMessage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.MeERP,
                        name: this.props.intl.formatMessage({ id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.MeERP}` }),
                        icon: ADMIN_ICON_LIST.MeERP,
                        render: () => (
                          <CardMeERP
                            selectedDivision={this.state.selectedDivision}
                            apiBaseUrl={CONFIG.API_HOST}
                            apiToken={this.controller.apiToken}
                            receiptWriteAccess={createPurReceiptRuntimeAccess({
                              apiBaseUrl: CONFIG.API_HOST,
                              apiToken: this.controller.apiToken,
                              divisionId: this.state.selectedDivision?.id,
                            })}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.IsChart,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.IsChart}`,
                        }),
                        icon: ADMIN_ICON_LIST.IsChart,
                        render: () => (
                          <CardIsChartWrapper
                            // key ต่างกัน = React remount ตอนสลับ tab -> Me.componentDidMount อ่าน isAdmin ใหม่
                            // (TabPenta render pane แบบ inline ไม่มี key ถ้าไม่ใส่ตรงนี้จะ reuse instance เดิม)
                            key="ischart"
                            config={CONFIG}
                            controller={this.controller}
                            loggedin={this.state.loggedin}
                            userProfile={this.state.userProfile}
                            selectedDivisionIHV3={this.state.selectedDivision}
                            permitToken={this.state.permitToken}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.AdminIsChart,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.AdminIsChart}`,
                        }),
                        icon: ADMIN_ICON_LIST.IsChart,
                        render: () => (
                          <CardIsChartWrapper
                            key="admin-ischart"
                            isAdmin={true}
                            config={CONFIG}
                            controller={this.controller}
                            loggedin={this.state.loggedin}
                            userProfile={this.state.userProfile}
                            selectedDivisionIHV3={this.state.selectedDivision}
                            permitToken={this.state.permitToken}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.MeChart,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.MeChart}`,
                        }),
                        icon: ADMIN_ICON_LIST.MeChart,
                        render: () => (
                          // <CardIsChartWrapper
                          //   controller={this.controller}
                          //   loggedin={this.state.loggedin}
                          //   userProfile={this.state.userProfile}
                          //   selectedDivisionIHV3={this.state.selectedDivision}
                          // />
                          <CardMeChart
                            controller={this.controller}
                            runSequence={this.runSequence}
                            setProp={this.controller.setProp}
                            MeChartSequence={this.state.MeChartSequence}
                            MeReportSequence={this.state.MeReportSequence}
                            productTypeOptions={this.state.masterOptions?.productType}
                            packageTypeOptions={this.state.masterOptions?.packageType}
                            searchedItemListWithKey={this.state.searchedItemListWithKey}
                            errorMessage={this.state.errorMessage}
                            successMessage={this.state.successMessage}
                            userProfile={this.state.userProfile}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.GenQRcode,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.GenQRcode}`,
                        }),
                        icon: ADMIN_ICON_LIST.GenQRcode,
                        render: () => <CardGenQRCode key="gen-qrcode" />,
                      },
                      {
                        key: ADMIN_NAME_LIST.MeCRM,
                        name: this.props.intl.formatMessage({id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.MeCRM}`}),
                        icon: ADMIN_ICON_LIST.MeCRM,
                        /* ⛔ ห้ามใส่ keepMounted — โมดูลผูกคีย์ลัด J/K/A ไว้ที่ window
                              ถ้าค้างไว้ การกดคีย์เหล่านั้นในเมนูอื่นจะไปสั่งอนุมัติคำขอ */
                        render: () => (
                          <CRMBackoffice
                            screen="claim-queue"
                            showNav
                            api={this.getCrmApi()}
                            divisionId={this.state.selectedDivision?.id}
                            userId={this.controller.data.user}
                            username={
                              this.state.providerEmployeeInfo?.employee_info?.full_name || ""
                            }
                            isSuperUser={!!this.controller.data.userProfile?.is_superuser}
                            embed="ishealth"
                            theme="innobic"
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST.MePOSCRM,
                        name: this.props.intl.formatMessage({
                          id: `ADMIN_MENU_NAME_${ADMIN_NAME_LIST.MePOSCRM}`,
                        }),
                        icon: ADMIN_ICON_LIST.MePOSCRM,
                        render: () => (
                          <CardMePOSCRM
                            controller={this.controller}
                            runSequence={this.runSequence}
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            MeGenSequence={this.state.MeGenSequence}
                            BillingAndPackageSequence={this.state.BillingAndPackageSequence}
                            goToMeGen={this.state.goToMeGen}
                            phlebotomyQueue={this.state.phlebotomyQueue}
                            meBillingActiveTab={this.state.meBillingActiveTab}
                            meBillingInitialMenu={this.state.meBillingInitialMenu}
                            MeBillingSequence={this.state.MeBillingSequence}
                            SaveServiceOrderSequence={this.state.SaveServiceOrderSequence}
                            divisionType={this.state.divisionType}
                            // medicalfee
                            patientInfo={this.state.selectedPatient}
                            selectedEncounter={this.state.selectedEncounter}
                            invoiceItemByModes={this.state.invoiceItemByModes}
                            invoiceItemByOrders={this.state.invoiceItemByOrders}
                            invoiceItemByItems={this.state.invoiceItemByItems}
                            patientOrders={this.state.patientOrders}
                            refundOrders={this.state.refundOrders}
                            medicalFeeFilter={this.state.medicalFeeFilter}
                            patientEncounterLockerStatus={this.state.patientEncounterLockerStatus}
                            encounterSuspension={this.state.encounterSuspension}
                            BillPaymentSequence={this.state.BillPaymentSequence}
                            taskTrackingList={this.state.taskTrackingList}
                            billPendingDetail={this.state.billPendingDetail}
                            bilReceiptCodeDetail={this.state.bilReceiptCodeDetail}
                            billReportPrint={this.state.billReportPrint}
                            faxClaimItemList={this.state.faxClaimItemList}
                            invoiceItemPackageList={this.state.invoiceItemPackageList}
                            billingPatientLanguage={this.state.billingPatientLanguage}
                            qrCodePayment={this.state.qrCodePayment}
                            // medicalfee history
                            MedicalFeeHistorySequence={this.state.MedicalFeeHistorySequence}
                            // common
                            languageUX={this.props.userSelectedLanguage}
                            masterOptions={this.state.masterOptions}
                            masterData={this.controller.data.masterData}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            successMessage={this.state.successMessage}
                            errorMessage={this.state.errorMessage}
                            loadingStatus={this.state.loadingStatus}
                            selectedDivision={this.state.selectedDivision}
                            searchedItemListWithKey={this.state.searchedItemListWithKey}
                            userProfile={this.state.userProfile}
                            // payment summary
                            PaymentSummarySequence={this.state.PaymentSummarySequence}
                            // payment history
                            PaymentHistorySequence={this.state.PaymentHistorySequence}
                            // package
                            PackagePurchaseSequence={this.state.PackagePurchaseSequence}
                            PackageOrderSequence={this.state.PackageOrderSequence}
                            // lab order
                            django={this.state.django}
                            selectedLabOrderWorking={this.state.selectedLabOrderWorking}
                            selectedContainer={this.state.selectedContainer}
                            selectedLabOrderItem={this.state.selectedLabOrderItem}
                            selectedLabOrderItemChild={this.state.selectedLabOrderItemChild}
                            labOrderItems={this.state.labOrderItems}
                            specimenLogs={this.state.specimenLogs}
                            specimenCollectorMasterData={this.state.specimenCollectorMasterData}
                            labOrderQueue={this.state.labOrderQueue}
                            // lab result
                            LabReportSequence={this.state.LabReportSequence}
                            // lab summary
                            OPDLabSummarySequence={this.state.OPDLabSummarySequence}
                            permissionLabResultConfidential={
                              this.state.permissionLabResultConfidential
                            }
                            selectedPatient={this.state.selectedPatient}
                            centralLabResultList={this.state.centralLabResultList}
                            // appointment
                            MakeAppointmentMeHeySequence={this.state.MakeAppointmentMeHeySequence}
                            // patient queue
                            PatientQueueSequence={this.state.PatientQueueSequence}
                            // print list
                            printListController={this.printListController}
                            // scanner
                            scannedDocumentController={this.scannedDocumentController}
                            patientData={this.state.patientData}
                          />
                        ),
                      },
                    ].filter((item: any): boolean => {
                      // console.log('item: ', item);
                      if (this.state.showRequestOA?.open) {
                        return false;
                      }

                      // if (item.name === ADMIN_NAME_LIST.Target && CONFIG.MENU_TARGET_SEGMENT) {
                      //   return true;
                      // }

                      // if (this.checkOATabMenu(item.name)) {
                      //   return true;
                      // }

                      const isVisible = !(
                        CONFIG.V3_HIDDEN_TAB_LIST.includes(item.key) || item.hide
                      );

                      const tabList =
                        this.state.divisionType === "backoffice"
                          ? MainHISI.BACK_OFFICE_ADMIN_TAB_LIST
                          : undefined;

                      const isInTabList = !tabList || tabList.includes(item.key);
                      // เงื่อนไขสิทธิ์การเข้าถึง
                      const hasAccess = canAccessAdminMenu(adminMenuAccessContext, item.key);

                      return isVisible && isInTabList && hasAccess;
                    })}
                    setProp={this.controller.setProp}
                    onChangeSelectedTabName={(name) => {
                      this.setState({ showTabName: name as string });
                    }}
                  />
                ) : this.state.mode === "patient" ? (
                  <TabPenta
                    languageUX={this.props.userSelectedLanguage}
                    ref={(ref: any) => (this.tabPatientRef = ref)}
                    key={"patient"}
                    padding="2px"
                    tabWidth="60px"
                    itemStyle={{
                      borderBottom: "1px solid rgba(217,217,217,0.4)",
                    }}
                    style={{ backgroundColor: "rgba(217, 217, 217, 0.41)" }}
                    renderEmpty={
                      isAccessPatient ? null : (
                        <div style={{ height: "100%", alignContent: "center" }}>
                          <div
                            style={{
                              borderRadius: "5px",
                              color: "white",
                              backgroundColor: "#4ec8f7",
                              margin: "auto",
                              padding: "1.75rem",
                              fontSize: "1.5rem",
                              width: "fit-content",
                            }}
                          >
                            ขออภัย ท่านไม่มีสิทธิ์ในการเข้าถึงข้อมูลของผู้ป่วยในแผนกนี้
                          </div>
                        </div>
                      )
                    }
                    {
                      ...(!CONFIG.RAKSTHAI_TAB_DEFAULT_MENU && {
                        selectedTabIndex: this.state.selectedTabIndex,
                      }) /// Feature 54669
                    }
                    // callback
                    onChangeSelectedTabName={(name, idx) => {
                      this.setState({ selectedTabPatientList: "" });
                      this.setState({ selectedTabIndex: idx });
                    }}
                    data={[
                      {
                        key: "Dashboard",
                        name: (
                          <div
                            style={{
                              ...styles.tab_icon,
                              padding: "0.85rem 0.375rem 0.85rem 0.275rem",
                            }}
                          >
                            <Popup
                              trigger={<Image src={IMAGES.report} />}
                              content={
                                this.props.userSelectedLanguage?.includes("th")
                                  ? "รายงาน & แดชบอร์ด"
                                  : "Report & Dashboard"
                              }
                              position="right center"
                            />
                          </div>
                        ),
                        render: () => (
                          <ErrorBoundary>
                            <CardQueueForPatient
                              // Dashboard
                              match={{ params: {} }}
                              ref={this.dashboardRef}
                              apiToken={this.controller.apiToken}
                              division={this.controller.data.division || 0}
                              controller={this.dashboardController}
                              onEvent={this.controller.handleEvent}
                              queueBill={this.state.queueBill}
                              masterOptions={this.state.masterOptions}
                              queueDrug={this.state.queueDrug}
                              queuePrepareDrug={this.state.queuePrepareDrug}
                              queueDoctor={this.state.queueDoctor}
                              phlebotomyQueue={this.state.phlebotomyQueue}
                              selectedDivision={this.state.selectedDivision}
                              // ODPDashboard
                              runSequence={this.runSequence}
                              setProp={this.controller.setProp}
                              TimeTrackingSequence={this.state.TimeTrackingSequence}
                              duckDBLoaded={this.state.duckDBLoaded}
                              appController={this.controller}
                              searchedItemListWithKey={this.state.searchedItemListWithKey}
                              languageUX={this.props.userSelectedLanguage}
                              django={this.state.django}
                              currentDoctor={this.state.currentDoctor}
                              divisionHasUserItems={this.state.divisionHasUserItems}
                            />
                          </ErrorBoundary>
                        ),
                      },
                      {
                        key: "Registration",
                        name: (
                          <div style={styles.tab_icon}>
                            <Popup
                              trigger={<Image src={IMAGES.search} />}
                              content="Search Patient"
                              position="right center"
                            />
                          </div>
                        ),
                        render: () => (
                          <ErrorBoundary>
                            <ViewRegistration.Main
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              setState={this.controller.setState}
                              runSequence={this.runSequence}
                              listView={ViewRegistration.listView(this)}
                              panelView={ViewRegistration.panelView(this)}
                              recordView={ViewRegistration.recordView(this)}
                              resetLayout={this.state.resetLayout}
                              initialLayout={this.state.initialLayout}
                              // get เลขที่ใบเสร็จ
                              bilReceiptCodeDetail={this.state.bilReceiptCodeDetail}
                              selectedDevice={this.state.selectedDevice}
                              showReceiptCode={this.state.divisionType === "การเงิน"}
                              onOpenVideoCall={(url: string, chat_channel_id: string) =>
                                this.setState({
                                  openVideoCallModal: true,
                                  videoCallRoom: url,
                                  currChatChannelId: chat_channel_id,
                                })
                              }
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </ErrorBoundary>
                        ),
                      },
                      {
                        key: "Encounter",
                        name: (
                          <div style={styles.tab_icon}>
                            <Popup
                              trigger={<Image src={IMAGES.queue} />}
                              content="Service Queue"
                              position="right center"
                            />
                          </div>
                        ),
                        render: () => {
                          // console.log("MainHIS render this.state.patientQueueEncounter", this.state.patientQueueEncounter)
                          return (
                            <ErrorBoundary>
                              <ViewEncounter.Main
                                onEvent={this.controller.handleEvent}
                                setProp={this.controller.setProp}
                                listView={ViewEncounter.listView(this)}
                                panelView={ViewEncounter.panelView(this)}
                                recordView={ViewEncounter.recordView(this)}
                                resetLayout={this.state.resetLayout}
                                initialLayout={this.state.initialLayout}
                                //PHV port
                                apiToken={this.controller.apiToken}
                                languageUX={this.props.userSelectedLanguage}
                              />
                            </ErrorBoundary>
                          );
                        },
                      },
                      {
                        key: "Appointment",
                        name: (
                          <div
                            style={{
                              ...styles.tab_icon,
                              padding: "0.8rem 0.85rem",
                            }}
                          >
                            <Popup
                              trigger={<Image src={IMAGES.appointment} />}
                              content="Appointment"
                              position="right center"
                              // languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                        render: () => (
                          <ViewAppointment.Main
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            setState={this.controller.setState}
                            runSequence={this.runSequence}
                            listView={ViewAppointment.listView(this)}
                            panelView={ViewAppointment.panelView(this)}
                            recordView={ViewAppointment.recordView(this)}
                            resetLayout={this.state.resetLayout}
                            onOpenVideoCall={(url: string, chat_channel_id: string) =>
                              this.setState({
                                openVideoCallModal: true,
                                videoCallRoom: url,
                                currChatChannelId: chat_channel_id,
                              })
                            }
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: "ChatSupport",
                        name: (
                          <div
                            style={{
                              ...styles.tab_icon,
                              padding: "0.8rem 0.85rem",
                            }}
                          >
                            <Popup
                              trigger={<Image src={IMAGES.chatSupport} />}
                              content="Chat Support"
                              position="right center"
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                        render: () => (
                          <ChatSupport
                            ref={(ref: any) => {
                              this.chatSupportRef = ref;
                              this.chatListRef = ref?.chatListRef || null;
                              return (this.chatBoxRef = ref?.chatBoxRef || null);
                            }}
                            setProp={this.controller.setProp}
                            allowCreateAppoint={true}
                            controller={this.chatController}
                            diagFormController={this.diagFormController}
                            classifyController={this.classifyController}
                            apiToken={this.controller.apiToken}
                            division={this.controller.data.division || 0}
                            userId={this.controller.data.user?.toString() || ""}
                            fullname={this.state.providerEmployeeInfo?.employee_info?.full_name}
                            username={this.state.django?.user?.full_name || ""}
                            finishedTriageLevel={this.finishedTriageLevel}
                            onNavigationMessage={this.handleNavigationMessage}
                            onEditAppointment={this.handleCreateAppointment}
                            isPatient={false}
                            onOpenVideoCall={(url: string, chat_channel_id: string) => {
                              this.setState({
                                openVideoCallModal: true,
                                videoCallRoom: url,
                                currChatChannelId: chat_channel_id,
                              });
                            }}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: "StaffChat",
                        name: (
                          <div
                            style={{
                              ...styles.tab_icon,
                              padding: "0.9rem 0.6rem 0.9rem 0.5rem",
                            }}
                          >
                            <Popup
                              trigger={<Image src={IMAGES.staffChat} />}
                              content="Staff Chat"
                              position="right center"
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                        render: () => (
                          <StaffChat
                            ref={(ref: any) => {
                              this.staffChatRef = ref;
                              return (this.chatBoxRef = ref?.chatBoxRef || null);
                            }}
                            onEvent={this.controller.handleEvent}
                            chatController={{
                              ...this.chatController,
                              ...this.chatController.msgManager,
                            }}
                            userId={this.controller.data.user?.toString() || ""}
                            userName={this.state.django?.user?.full_name || ""}
                            userLastName={this.controller.data.userProfile?.last_name || ""}
                            userFirstName={this.controller.data.userProfile?.first_name || ""}
                            // userId={"5727"}
                            // userName={"พยาบาล ดุจดาว"}
                            apiToken={this.controller.apiToken}
                            divisionId={this.state.selectedDivision?.id}
                            chatRoomList={this.state.chatRoomList}
                            searchUserList={this.state.searchUserList}
                            searchMessageList={this.state.searchMessageList}
                            onReadAllMessages={this.handleReadAllMessages}
                            onOpenVideoCall={(url: string, chat_channel_id: string) =>
                              this.setState({
                                openVideoCallModal: true,
                                videoCallRoom: url,
                                currChatChannelId: chat_channel_id,
                              })
                            }
                            onDidMount={this.handleStaffChatDidMount}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: "MemberHealthKit",
                        name: (
                          <div
                            style={{
                              ...styles.tab_icon,
                              padding: "0.8rem 0.85rem",
                            }}
                          >
                            <Popup
                              trigger={<Image src={IMAGES.memberHealthKit} />}
                              content="Member HealthKit"
                              position="right center"
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </div>
                        ),
                        render: () => (
                          <MemberHealthKit.Main
                            runSequence={this.runSequence}
                            setProp={this.controller.setProp}
                            onEvent={this.controller.handleEvent}
                            panelView={MemberHealthKit.panelView(this)}
                            recordView={MemberHealthKit.recordView(this)}
                            HealthMemberSequence={this.state.HealthMemberSequence}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      // {
                      //   key: "PathwayOld",
                      //   name: (
                      //     <div
                      //       style={{
                      //         ...styles.tab_icon,
                      //         padding: "0.8rem 0.8rem 0.5rem 0.2rem",
                      //       }}
                      //     >
                      //       <Popup
                      //         trigger={<Image src={IMAGES.telemed} />}
                      //         content="TeleHealth"
                      //         position="right center"
                      //       />
                      //     </div>
                      //   ),
                      //   render: () => (
                      //     // <ViewPathwayOld.Main
                      //     //   ref={this.qaChatTable}
                      //     //   onEvent={this.controller.handleEvent}
                      //     //   listView={ViewPathwayOld.listView(this)}
                      //     //   panelView={ViewPathwayOld.panelView(this)}
                      //     //   recordView={ViewPathwayOld.recordView(this)}
                      //     //   resetLayout={this.state.resetLayout}
                      //     //   context={this}
                      //     // />

                      //     <>
                      //       <ModSelectAppointment
                      //         controller={this.queueController}
                      //         open={this.state.openModChooseAppointment}
                      //         onClose={() => {
                      //           this.setState({
                      //             patientAppointmentId: null,
                      //             openModChooseAppointment: false,
                      //           });
                      //           // setPatientAppointmentId(null);
                      //           // setOpenModChooseAppointment(false);
                      //         }}
                      //         patientAppointmentId={
                      //           this.state.patientAppointmentId
                      //         }
                      //         division={this.controller.data.division || 0}
                      //       />

                      //       <QAChatTable
                      //         setState={this.controller.setState}
                      //         getState={this.controller.getState}
                      //         // for backward complatible
                      //         // diagFormId={this.state?.QAChatTable?.diagFormId}
                      //         // triageLevel={this.state?.QAChatTable?.triageLevel}

                      //         // apiToken={props.apiToken}
                      //         apiToken={this.controller.apiToken}
                      //         // division={props.division}
                      //         division={this.controller.data.division || 0}
                      //         // finishedTriageLevel={props.finishedTriageLevel}
                      //         finishedTriageLevel={
                      //           this.state.finishedTriageLevel
                      //         }
                      //         // {...props}
                      //         // มาจาก MainScreen props ทั้งหมด และ render props ของ react-router บน Platform
                      //         // แต่ render props ถูก override ด้วย render props ของ Main screen

                      //         // ref={(ref) => (this.mainScreen = ref)} // Override

                      //         // Not used
                      //         // getLeftMenuItem={this.getLeftMenuItem}
                      //         // getDivisionMenuItem={this.getDivisionMenuItem}
                      //         // getRightMenuItem={this.getRightMenuItem}
                      //         // chatController={this.ChatController}
                      //         // appointmentChatController={this.AppointmentChatController}
                      //         // ruleListController={this.ruleListController}
                      //         // diagComposerController={this.diagComposerController}

                      //         // Override
                      //         // diagFormController={this.diagFormController}
                      //         // patientPanelController={this.patientPanelController}
                      //         // nurseNoteController={this.nurseNoteController}
                      //         // progressNoteController={this.progressNoteController}

                      //         // Not used
                      //         // bindHNPageController={this.bindHNPageController}

                      //         // Override
                      //         // crdVitalSignController={this.crdVitalSignController}

                      //         // Not used
                      //         // appointmentDashboardController={
                      //         //   this.appointmentDashboardController
                      //         // }

                      //         // Override
                      //         // classifyController={this.classifyController}
                      //         // apiToken={this.state.apiToken}
                      //         // onGetDivision={this.loadMydivision}
                      //         // division={this.state.division}
                      //         // userId={this.state.userId}
                      //         // fullname={this.state.fullname}
                      //         // username={this.state.username}
                      //         // finishedTriageLevel={this.state.finishedTriageLevel}

                      //         // Override
                      //         // queueController={this.queueController}
                      //         // dashboardController={this.dashboardController}

                      //         // Not used
                      //         // regChatController={this.regChatController}
                      //         // bilPatientPanelController={this.bilPatientPanelController}
                      //         // onReconnectWs={this.reconnectWs}
                      //         // onEvent={this.controller.handleEvent}
                      //         // patientSegmentList={this.state.patientSegmentList}
                      //         // diagFormDetail={this.state.diagFormDetail}
                      //         // divisionProfileList={this.state.divisionProfileList}
                      //         // isLoadingFormAnalytics={this.state.isLoadingFormAnalytics}
                      //         // myDivisions={this.state.myDivisions}
                      //         // storage={this.controller.storage}
                      //         // getDivision={this.getDivision}
                      //         // onSetState={(state: any) => this.setState({ ...state })}
                      //         // isVerified={this.state.isVerified}
                      //         // goToRegister={this.handleGoToRegister}
                      //         // vaccineInfo={this.state.vaccineInfo}
                      //         // appointmentList={this.state.appointmentList}
                      //         // generateUserModal={this.state.generateUserModal}
                      //         // generateUserResult={this.state.generateUserResult}

                      //         //Feature #54627 Override
                      //         // patientADR={this.state.patientADR}
                      //         /// Enb {...props}

                      //         // {...chatProps}
                      //         // react-router
                      //         // props.match.params ถ้ามี params คือ ใช้บน MainScreen

                      //         // pass new props
                      //         diag_rule={this.state?.QAChatTable?.diag_rule}
                      //         match={{
                      //           params: {
                      //             triageLevel:
                      //               this.state?.QAChatTable?.triageLevel,
                      //             diagFormId:
                      //               this.state?.QAChatTable?.diagFormId,
                      //           },
                      //         }} // จำลอง react-router คืน
                      //         noReactRouter={true}
                      //         // ref={qaChatTable}
                      //         ref={(ref: any) => (this.qaChatTableRef = ref)}
                      //         allowCreateAppoint={
                      //           CONFIG.BOOKING_FUNCTION ? true : false
                      //         }
                      //         // Edit
                      //         // Controller
                      //         controller={{
                      //           ...this.chatController,
                      //           regManager: this.proxyController,
                      //           prxManager: this.proxyController,
                      //         }}
                      //         diagFormController={this.diagFormController}
                      //         patientPanelController={
                      //           this.patientPanelController
                      //         }
                      //         nurseNoteController={{
                      //           ...this.proxyController,
                      //           ...this.nurseNoteController,
                      //         }}
                      //         progressNoteController={
                      //           this.progressNoteController
                      //         }
                      //         classifyController={this.classifyController}
                      //         crdVitalSignController={
                      //           this.crdVitalSignController
                      //         }
                      //         onGetDivision={() => {}} // เรียกตอน useEffect[] ดังนั้น initial ตั้งแต่แรกไปเลย
                      //         dashboardController={this.dashboardController}
                      //         queueController={this.queueController}
                      //         // Data
                      //         userId={this.controller.data.user || 0}
                      //         // fullname={this.state.fullname}
                      //         // username={this.state.username}
                      //         storage={this.controller.storage}
                      //         isPatient={false}
                      //         autoHeight={true}
                      //         classifyFromDiagRule={true}
                      //         // Callback
                      //         onNavigationMessage={this.handleNavigationMessage}
                      //         onEditAppointment={this.handleCreateAppointment}
                      //         // config
                      //         AIRFLOW_CHAT={true}
                      //         //Feature #54627
                      //         patientADR={this.state.patientADR}
                      //       />
                      //     </>
                      //   ),
                      // },
                      // {
                      //   key: "Content",
                      //   name: <Icon name="images" />,
                      //   render: () =>
                      //     <ViewContent.Main
                      //       onEvent={this.controller.handleEvent}
                      //       setProp={this.controller.setProp}
                      //       setState={this.controller.setState}
                      //       runSequence={this.runSequence}
                      //       listView={ViewContent.listView(this)}
                      //       panelView={ViewContent.panelView(this)}
                      //       recordView={ViewContent.recordView(this)}
                      //       resetLayout={this.state.resetLayout}
                      //     />
                      // },

                      // {
                      //   key: "Pathway",
                      //   name: <Icon name="home" />,
                      //   render: () =>
                      //     <ViewPathway.Main
                      //       onEvent={this.controller.handleEvent}
                      //       listView={ViewPathway.listView(this)}
                      //       panelView={ViewPathway.panelView(this)}
                      //       recordView={ViewPathway.recordView(this)}
                      //       resetLayout={this.state.resetLayout}
                      //     />
                      // },
                      // {
                      //   key: "Accounting",
                      //   name: <Icon name="save" />,
                      //   render: () =>
                      //     <ViewAccounting.Main
                      //       onEvent={this.controller.handleEvent}
                      //       setProp={this.controller.setProp}
                      //       setState={this.controller.setState}
                      //       runSequence={this.runSequence}
                      //       listView={ViewAccounting.listView(this)}
                      //       panelView={ViewAccounting.panelView(this)}
                      //       recordView={ViewAccounting.recordView(this)}
                      //       resetLayout={this.state.resetLayout}
                      //     />
                      // },
                    ].filter((item: any): boolean => {
                      const screenItems =
                        CONFIG.SCREEN_ITEM?.map((screenItem: Record<string, any>) =>
                          screenItem.extra ? JSON.parse(screenItem.extra)?.key || "" : "",
                        ).filter(Boolean) || [];

                      const isVisible = CONFIG.SIDEMENU_SCREEN_CONFIG
                        ? screenItems.includes(item.key) && !item.hide
                        : true;

                      const tabList =
                        this.state.divisionType === "backoffice" ? ["Registration"] : undefined;

                      const isInTabList = !tabList || tabList.includes(item.key);

                      return isVisible && isInTabList && isAccessPatient;
                    })}
                    setProp={this.controller.setProp}
                  />
                ) : this.state.mode === "user" ? (
                  <TabPenta
                    ref={(ref: any) => (this.tabUserRef = ref)}
                    selectedTabIndex={this.state.goToStaffChat ? 1 : 0}
                    key={"user"}
                    style={{
                      ...(this.state.showRequestOA?.open && { marginLeft: "-150px" }),
                    }}
                    tutorials={this.state.menuHasVideos}
                    renderEmpty={
                      this.state.showRequestOA?.open ? (
                        <ShowRequestOA
                          controller={this.proxyController}
                          apiToken={this.controller.apiToken}
                          myDivisions={[{}, {}]}
                          onBackToMain={() => {
                            this.setState({ showRequestOA: null });
                          }}
                        />
                      ) : null
                    }
                    tabWidth="150px"
                    data={[
                      {
                        key: ADMIN_NAME_LIST.ข้อมูลส่วนตัว,
                        name: ADMIN_NAME_LIST.ข้อมูลส่วนตัว,
                        icon: ADMIN_ICON_LIST.ข้อมูลส่วนตัว,
                        hide: true,
                        render: () => (
                          <UserProfile
                            controller={this.proxyController}
                            functionsWithRegion={this.controller.functions}
                            isLineLogin={this.state.loginWithSocial === "line"}
                            isGoogleLogin={this.state.loginWithSocial === "google"}
                            isFacebookLogin={this.state.loginWithSocial === "facebook"}
                            // isEmailLogin={this.state.isEmailLogin}
                            // emailLogin={this.state.emailLogin}
                            layout="detailed"
                            userId={this.controller.data.user}
                            onRefreshUserInfo={this.handleRefreshUserInfo}
                            onCreateOA={() => {
                              this.tabUserRef.changeTabKey("สร้าง Official Account");
                            }}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            selectedDivision={this.state.selectedDivision}
                            divisionHasUserItems={this.state.divisionHasUserItems}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: "Doctor Schedule",
                        name: "Doctor Schedule",
                        render: () => (
                          <CardDoctorSchedule
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            runSequence={this.runSequence}
                            selectedDivision={this.state.selectedDivision}
                            SetScheduleSequence={this.state.SetScheduleSequence}
                            searchedItemList={this.state.searchedItemList}
                            selectedProvider={this.state.providerInfo}
                            holiday={this.state.holiday}
                            providerBlockList={this.state.providerBlockList}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: "Staff Chat",
                        hide: CONFIG.HIDE_STAFF_CHAT_ADMIN_MODE,
                        name: (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <label>Staff Chat</label>
                            {this.state.showIconNoti && (
                              <Label
                                data-testid="msg-noti"
                                circular
                                color={"red"}
                                style={{ fontSize: "0.3rem" }}
                              ></Label>
                            )}
                          </div>
                        ),
                        render: () => (
                          <StaffChat
                            ref={(ref: any) => {
                              this.staffChatRef = ref;
                              return (this.chatBoxRef = ref?.chatBoxRef || null);
                            }}
                            onEvent={this.controller.handleEvent}
                            chatController={{
                              ...this.chatController,
                              ...this.chatController.msgManager,
                            }}
                            userId={this.controller.data.user?.toString() || ""}
                            userName={this.state.django?.user?.full_name || ""}
                            userLastName={this.controller.data.userProfile?.last_name || ""}
                            userFirstName={this.controller.data.userProfile?.first_name || ""}
                            // userId={"5727"}
                            // userName={"พยาบาล ดุจดาว"}
                            apiToken={this.controller.apiToken}
                            divisionId={this.state.selectedDivision?.id}
                            chatRoomList={this.state.chatRoomList}
                            searchUserList={this.state.searchUserList}
                            searchMessageList={this.state.searchMessageList}
                            onReadAllMessages={this.handleReadAllMessages}
                            onOpenVideoCall={(url: string, chat_channel_id: string) =>
                              this.setState({
                                openVideoCallModal: true,
                                videoCallRoom: url,
                                currChatChannelId: chat_channel_id,
                              })
                            }
                            onDidMount={this.handleStaffChatDidMount}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: "Doctor Schedule Old",
                        name: "Doctor Schedule Old",
                        render: () => (
                          <DoctorSchedule
                            // {...this.props}
                            // {...routeProps}
                            show="DoctorSchedule"
                            match={this.state.matchCompat}
                            apiToken={this.controller.apiToken}
                            division={this.controller.data.division || 0}
                            controller={this.dashboardController}
                            queueController={this.queueController}
                            providerId={this.controller.data.provider || 0}
                            // id={}
                            // weekStartSerial={}
                            onClickDaySlot={({ index, weekStartSerial }: any) => {
                              console.log(index, weekStartSerial);
                              this.setState({
                                matchCompat: {
                                  params: {
                                    id: index,
                                    weekStartSerial: weekStartSerial,
                                  },
                                },
                              });
                            }}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: "DoctorFee_Report_Old",
                        name: "DoctorFee Report",
                        render: () => (
                          <CardDoctorFeeReportOld
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            runSequence={this.runSequence}
                            SetDoctorFeeReportSequence={this.state.SetDoctorFeeReportSequence}
                            searchedItemList={this.state.searchedItemList}
                            selectedProvider={this.state.providerInfo}
                            errorMessage={this.state.errorMessage}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: "DoctorFee_Report",
                        name: "DoctorFee Report",
                        // hide: CONFIG.HIDE_DOCTOR_FEE_ALL_MENU, // 67071 hide
                        render: () => (
                          <CardDoctorFeeReport
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            // seq
                            runSequence={this.runSequence}
                            DoctorFeeReportSequence={this.state.DoctorFeeReportSequence}
                            // options
                            masterOptions={this.state.masterOptions}
                            // CommonInterface
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            errorMessage={this.state.errorMessage}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: "Telemed record",
                        name: "Telemed record",
                        render: () => (
                          <CardTelemedRecord
                            controller={this.controller}
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            runSequence={this.runSequence}
                            selectedDivision={this.state.selectedDivision}
                            SetDoctorFeeReportSequence={this.state.SetDoctorFeeReportSequence}
                            searchedItemList={this.state.searchedItemList}
                            selectedProvider={this.state.providerInfo}
                            languageUX={this.props.userSelectedLanguage}
                            divisionList={this.state.divisionList}
                          />
                        ),
                      },
                      {
                        key: "Profile",
                        name: "Profile",
                        render: () =>
                          CONFIG.COMPANY === "MSK" ? (
                            <CardEmployeeProfile
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              runSequence={this.runSequence}
                              DSPermissionSequence={this.state.DSPermissionSequence}
                              EmployeeDocumentSequence={this.state.EmployeeDocumentSequence}
                              EmployeeHistorySequence={this.state.EmployeeHistorySequence}
                              EmployeeInfoSequence={this.state.EmployeeInfoSequence}
                              EmployeePaymentSequence={this.state.EmployeePaymentSequence}
                              allDivisionGroup={this.controller.data.allDivisionGroup}
                              changePassword={this.state.changePassword}
                              employeeId={this.controller.data.userProfile?.employee}
                              hideTabs={EMPLOYEE_SELF_PROFILE_HIDDEN_TABS}
                              readOnly
                              selectedEmployee={this.state.selectedEmployee}
                              userId={this.controller.data.userProfile?.id}
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              languageUX={this.props.userSelectedLanguage}
                              masterData={this.controller.data.masterData}
                              successMessage={this.state.successMessage}
                              masterOptions={this.state.masterOptions}
                            />
                          ) : (
                            <CardStaffSetting
                              setProp={this.controller.setProp}
                              onEvent={this.controller.handleEvent}
                              // Controller
                              controller={this.controller}
                              proxyController={this.proxyController}
                              // staffList={this.state.staffList}
                              // data
                              profileUser={this.state.profileUser}
                              changePassword={this.state.changePassword}
                              profileDivision={this.state.profileDivision}
                              profileEmployee={this.state.profileEmployee}
                              settingsUser={this.state.settingsUser}
                              // options
                              masterOptions={this.state.masterOptions}
                              roleOptions={this.state.roleOptions}
                              divisionOptions={this.state.divisionOptions}
                              masterData={this.controller.data.masterData}
                              // CommonInterface
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              errorMessage={this.state.errorMessage}
                              successMessage={this.state.successMessage}
                              // config
                              editUserProfile={this.controller.data.userProfile}
                              mode="edit"
                              tab="user-employee"
                              hideTabDivision={true}
                              hideEmployeeForm={true}
                              hideButtonBack={true}
                              fetchOptionsOnly={true}
                              showPassword2={true}
                              pw2CheckTeacherFlag={true}
                              languageUX={this.props.userSelectedLanguage}
                            />
                          ),
                      },
                      {
                        key: "Account",
                        name: "Account",
                        render: () => (
                          <CardAccountInformation
                            setProp={this.controller.setProp}
                            runSequence={this.runSequence}
                            AccountInformationSequence={this.state.AccountInformationSequence}
                            loginWithSocial={this.state.loginWithSocial}
                            userEmail={this.controller.data?.userProfile?.email}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            errorMessage={this.state.errorMessage}
                          />
                        ),
                      },
                      {
                        key: ADMIN_NAME_LIST["สร้าง Official Account"],
                        name: ADMIN_NAME_LIST["สร้าง Official Account"],
                        icon: ADMIN_ICON_LIST["สร้าง Official Account"],
                        hide: true,
                        render: () => (
                          <CreateOA
                            onEvent={this.controller.handleEvent}
                            controller={this.classifyController}
                            apiToken={this.controller.apiToken}
                            onGetDivision={(divisionId: any) => {}} // Already handled in AppInitialize:GetUserInfo
                            myDivisions={this.state.divisionOptions}
                            layout="detailed"
                            onSetShowMenuNoti={(show: any) => this.setState({ showMenuNoti: show })}
                            userFullName={this.state.providerEmployeeInfo?.employee_info?.full_name}
                            userRoleList={this.state.userRoleList}
                            masterData={this.controller.data.masterData}
                            masterOptions={this.state.masterOptions}
                            onCreated={(divisionId: number) =>
                              this.controller.handleEvent({
                                message: "HandleCreatedOA",
                                params: { divisionId },
                              })
                            }
                            onSuccess={() => {
                              this.setState({ mode: "admin" });
                            }}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                    ].filter((item: any): boolean => {
                      if (this.state.showRequestOA?.open) {
                        return false;
                      }

                      if (this.checkOATabMenu(item.key)) {
                        return true;
                      }

                      return !(CONFIG.V3_HIDDEN_TAB_LIST.includes(item.key) || item.hide);
                    })}
                    setProp={this.controller.setProp}
                    onChangeSelectedTabName={(name) => {
                      this.setState({ showTabName: name as string });
                    }}
                  />
                ) : this.state.mode === "segment" ? (
                  <TabPenta
                    languageUX={this.props.userSelectedLanguage}
                    selectedTabIndex={0}
                    key={"segment"}
                    tabWidth="125px"
                    data={[
                      {
                        key: "Underlying disease",
                        name: "Underlying disease",
                        render: () => (
                          <CardUnderlyingDisease
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            // controller
                            drugOrderQueueController={this.drugOrderQueueController}
                            // seq
                            runSequence={this.runSequence}
                            UnderlyingDiseaseSequence={this.state.UnderlyingDiseaseSequence}
                            // CommonInterface
                            errorMessage={this.state.errorMessage}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                      {
                        key: "Risk Alert",
                        name: "Risk Alert",
                        render: () => <></>,
                      },
                      {
                        key: "Drug-Disease interaction",
                        name: "Drug-Disease interaction",
                        render: () => (
                          <>
                            <CardDrugDiseaseInteraction
                              onEvent={this.controller.handleEvent}
                              setProp={this.controller.setProp}
                              // seq
                              runSequence={this.runSequence}
                              DrugDiseaseInteractionSequence={
                                this.state.DrugDiseaseInteractionSequence
                              }
                              // CommonInterface
                              errorMessage={this.state.errorMessage}
                              buttonLoadCheck={this.state.buttonLoadCheck}
                              searchedItemListWithKey={this.state.searchedItemListWithKey}
                              // options
                              masterOptions={this.state.masterOptions}
                              languageUX={this.props.userSelectedLanguage}
                            />
                          </>
                        ),
                      },
                      {
                        key: "Health Member",
                        name: "Health Member",
                        render: () => (
                          <CardHealthMember
                            onEvent={this.controller.handleEvent}
                            setProp={this.controller.setProp}
                            // seq
                            runSequence={this.runSequence}
                            HealthMemberSequence={this.state.HealthMemberSequence}
                            // controller
                            drugOrderQueueController={this.drugOrderQueueController}
                            // CommonInterface
                            errorMessage={this.state.errorMessage}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            searchedItemListWithKey={this.state.searchedItemListWithKey}
                            languageUX={this.props.userSelectedLanguage}
                          />
                        ),
                      },
                    ]}
                    setProp={this.controller.setProp}
                  />
                ) : this.state.mode === "seller" ? (
                  <TabPenta
                    ref={(ref: any) => (this.tabSellerRef = ref)}
                    languageUX={this.props.userSelectedLanguage}
                    key={"seller"}
                    tabWidth="150px"
                    collapsible
                    data={[
                      {
                        key: "Setting Package",
                        name: "Setting Package",
                        render: () => (
                          <CardSellerSettingPackage
                            setProp={this.controller.setProp}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            onEvent={this.controller.handleEvent}
                            meHealthPackageList={this.state.meHealthPackageList}
                            termsAndConditionsList={this.state.termsAndConditionsList}
                            latestTermAndConditions={this.state.latestTermAndConditions}
                            termsAndConditionsActionLogList={
                              this.state.termsAndConditionsActionLogList
                            }
                          />
                        ),
                      },
                      {
                        key: "Broadcast Approval",
                        name: "Broadcast Approval",
                        render: () => (
                          <CardMeCastBroadcastApproval
                            MeCastSequence={this.state.MeCastSequence}
                            setProp={this.controller.setProp}
                            runSequence={this.runSequence}
                            onEvent={this.controller.handleEvent}
                            // common
                            errorMessage={this.state.errorMessage}
                            successMessage={this.state.successMessage}
                            buttonLoadCheck={this.state.buttonLoadCheck}
                            loadingStatus={this.state.loadingStatus}
                          />
                        ),
                      },
                      {
                        key: "Lab Cost",
                        name: "Lab Cost",
                        render: () => <CardLabCost />,
                      },
                    ]}
                    setProp={this.controller.setProp}
                  />
                ) : this.state.mode === "ischart" ? (
                  <>
                    <Me
                      view="chart"
                      useCloud={true}
                      Admin={null}
                      IHV3={true}
                      config={{ ...CONFIG, ISCHART_INFORMATICS_GS, ISCHART_STUDIO_GS }}
                      controller={this.controller}
                      loggedin={this.state.loggedin}
                      userProfile={this.state.userProfile}
                      selectedDivisionIHV3={this.state.selectedDivision}
                    />{" "}
                  </>
                ) : this.state.mode === "cms" ? (
                  <>
                    <ClinicCMS
                      divisionId={this.state.selectedDivision?.id}
                      apiToken={this.controller.apiToken}
                      apiBaseUrl={CONFIG.API_HOST}
                    />{" "}
                  </>
                ) : (
                  <></>
                )
              }
            </div>
          </div>
        )}

        <CardNotiMessage
          setProp={this.controller.setProp}
          notificationMessageList={this.state.notificationMessageList}
        />

        <CardBillLockNotiMessage
          onEvent={this.controller.handleEvent}
          setProp={this.controller.setProp}
          notificationMessageList={this.state.billLockNotiMessageList}
          tabPatientRef={this.tabPatientRef}
        />

        <CardDialogChatList
          onEvent={this.controller.handleEvent}
          setProp={this.controller.setProp}
          allAdminChatRoomList={this.state.allAdminChatRoomList}
          patientHNChatList={this.state.patientHNChatList}
          chatController={this.chatController}
          apiToken={this.controller.apiToken}
          divisionId={this.state.selectedDivision?.id}
          userId={this.controller.data.user || ""}
        />

        <SnackMessage
          error={this.state.divisionHasUserErrorMessage}
          success={null}
          onClose={() => {
            this.setState({ divisionHasUserErrorMessage: "" });
          }}
        />

      </div>
    );
  }
}

export default LocalizationWrapper(injectIntl(MainHIS));
